<template>

<div id="form-container" ref="formContainer">
    <div v-if="initialPageLoading">
        <div class="text-center">
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div>
    </div>

    <div v-else>
      <b-button style="float:right;" type="button" variant="primary" @click="goBack">Back</b-button>
        <h1>HRM Request for {{ request.requestTypeValue.description }}</h1>


        <div class="card">
            <div class="card-header">Request Status</div>
            <div class="card-body">
                <b-row>
                    <b-col cols="3">
                        <p><strong>Tracking #</strong></p>
                        <h2>{{request.mdhTrackingId}}</h2>
                        <div v-if="request.jobId" style="font-size:.90em;">
                             {{ request.jobId }}
                        </div>
                        <div>{{ request.requestTypeValue.description }}</div>
                    </b-col>
                    <b-col cols="3">
                        <p>Status</p>
                        <h2>{{ request.requestStatusValue.description }}</h2>
                        <span></span>
                    </b-col>
                    <b-col class="float-right">
                        <div v-if="request.requestStatusValue.code !== '22204'" class="float-right">
                            <b-button type="button" variant="primary" v-b-modal.pcnUpdateModal
                                v-if="request.requestTypeValue.code !== '01' && false">Update PCN</b-button>
                             <b-button type="submit" variant="primary"
                                v-if="request.requestStatusValue.code !== '05'
                                    && !needsMyApproval
                                    && isAssigned
                                    && !isHiringManager
                                    && !request.completed"
                                @click="putOnHold">Place Request on Hold</b-button>
                            <b-button type="submit" variant="primary"
                                v-if="(showCancelButton && !needsMyApproval && isAssigned)"
                                @click="cancelRequest">Cancel this Request</b-button>
                            <b-button type="submit" variant="primary"
                                v-if="request.requestStatusValue.code === '05' && isAssigned"
                                @click="removeHold">Remove Hold</b-button>
                          <b-button type="submit" variant="primary"
                                    v-if="request.requestTypeValue.code === '10' && request.requestStatusValue.code === '22'"
                                    @click="reopenLeave">Reopen Leave Request</b-button>
                        </div>

                    </b-col>

                </b-row>
                <b-row v-if="request.requestDelegable === true && isPrimaryAssigned">
                <!--  Remove Request Delegation section  -->
                </b-row>
            </div>
        </div>
    <AssignedLifecycle v-if="isAssignedLifecycle" v-bind:request="request"
        v-on:status-changed="fetchRequest()"/>
    <RequesterReviewLifecycle v-if="isRequesterReviewLifecycle" v-bind:request="request"
        v-on:status-changed="fetchRequest()"/>    
    <AuditLifecycle v-if="isAuditLifecycle" v-bind:request="request"
        v-on:status-changed="fetchRequest()"/>
    <AssignSpecialist v-if="isUnassigned" v-bind:request="request"/>
    <CFOReview v-if="isReadyForCFOReview" v-bind:request="request"/>
    <DraftPostingLifecycle v-if="isDraftPosting && !isAssignPcn" v-bind:request="request"
        v-on:status-changed="fetchRequest()"/>
    <RequesterReviewPostingLifecycle v-if="isReviewPosting" v-bind:request="request"
        v-on:status-changed="fetchRequest()"/>        
    <PostedLifecycle v-if="isPosted" v-bind:request="request"
        v-on:status-changed="fetchRequest()"/>
    <RePostedLifecycle v-if="isReposted" v-bind:request="request"
        v-on:status-changed="fetchRequest()"/>
    <ScreenApplicantsLifecycle v-if="isScreening" v-bind:request="request"
        v-on:status-changed="fetchRequest()"/>
    <ManagerInterviewLifecycle v-if="isManagerInterviewing" v-bind:request="request"
        v-on:status-changed="fetchRequest()"/>
    <PreOfferLifecycle v-if="isPreOffer" v-bind:request="request"
        v-on:status-changed="fetchRequest()"/>
    <SalaryLifecycle v-if="isSalaryReview" v-bind:request="request"
        v-on:status-changed="fetchRequest()"/>
    <OfferLifecycle v-if="isOffer" v-bind:request="request"
        v-on:status-changed="fetchRequest()"/>
    <MakeOfferLifecycle v-if="isMakeOffer" v-bind:request="request"
        v-on:status-changed="fetchRequest()"/>
    <BackgroundLifecycle v-if="isBackgroundCheck" v-bind:request="request"
        v-on:status-changed="fetchRequest()"/>
    <CompleteLifecycle v-if="isComplete && !isCloseOut" v-bind:request="request"
        v-on:status-changed="fetchRequest()"/>
    <RDCLifecycle v-if="isRDCSubmission" v-bind:request="request"
        v-on:status-changed="fetchRequest()"/>
    <RDCCandidate v-if="isRDCCandidate" v-bind:request="request"
        v-on:status-changed="fetchRequest()"/>
    <RDCOnboard v-if="isRDCOnboard" v-bind:request="request"
        v-on:status-changed="fetchRequest()"/>
    <AssignPCN v-if="isAssignPcn"  v-bind:request="request"
        v-on:status-changed="fetchRequest()"/>
    <UpdatePCN v-if="isUpdatePcn"  v-bind:request="request"
        v-on:status-changed="fetchRequest()"/>
    <CloseOutTransactionLifecycle v-if="isComplete && isCloseOut" v-bind:request="request"
        v-on:status-changed="fetchRequest()"/>
    <TransactionPPLLifecycle v-if="isTransactionPPL" v-bind:request="request"
        v-on:status-changed="fetchRequest()"/>

    <PayrollReviewLifecycle v-if="hasPayrollRole && hasPayrollStatus" v-bind:request="request" v-on:status-changed="fetchRequest()"/>
    <PayrollFMLA v-if="hasPayrollRole && (_.includes(['FMLA'],payrollAction) || findPayrollActionStatus(31))" v-bind:request="request" v-on:status-changed="fetchRequest()"/>
    <PayrollPPL v-if="hasPayrollRole && (_.includes(['PPL'],payrollAction) || findPayrollActionStatus(30))" v-bind:request="request" v-on:status-changed="fetchRequest()"/>

    <div v-if="needsMyApproval">
        <div class="card">
            <div class="card-header">Your Approval is Required</div>
            <div class="card-body">
                <form-summary :validator="$v.needsMyApproval" ref="errorContainer" id="errorContainer"/>

                <b-form @submit.stop.prevent="onSubmit">
                    <b-row>
                        <b-col cols="12" lg="6">
                            <BaseSelector v-model="needsMyApproval.approvalStatus"
                                :v="$v.needsMyApproval.approvalStatus"
                                label="Approval Decision"
                                slug="approvalDecision"
                                :options = approvalStatusOptions />
                        </b-col>
                        <b-col cols="12" lg="6">
                            <BaseParagraphInput v-model="needsMyApproval.comments"
                                :v="$v.needsMyApproval.comments"
                                label="Comments"
                                slug="approvalComments"
                                tip="Summarize in 1000 characters or less the approval decision."/>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-overlay :show="isProcessing" rounded opacity="0.6"
                                       spinner-small spinner-variant="primary"
                                       class="d-inline-block">
                                <b-button type="submit" variant="primary">
                                    Submit Approval Decision
                                </b-button>
                            </b-overlay>
                        </b-col>
                    </b-row>
                </b-form>
            </div>
        </div>
    </div>

    <div v-if="needsMyICSApproval">
        <div class="card">
            <div class="card-header">Your ICS Approval is Required</div>
            <div class="card-body">
                <form-summary :validator="$v.needsMyICSApproval" ref="errorContainer" id="errorContainer"/>

                <b-form @submit.stop.prevent="onICSApproval">
                    <b-row>
                        <b-col cols="12" lg="6">
                            <BaseSelector v-model="needsMyICSApproval.approvalStatus"
                                :v="$v.needsMyICSApproval.approvalStatus"
                                label="Approval Decision"
                                slug="approvalDecision"
                                :options = approvalStatusOptions
                                :required="$v.needsMyICSApproval.approvalStatus.$params.required" />
                        </b-col>
                        <b-col cols="12" lg="6">
                            <BaseParagraphInput v-model="needsMyICSApproval.comments"
                                :v="$v.needsMyICSApproval.comments"
                                label="Comments"
                                slug="approvalComments"
                                :required="$v.needsMyICSApproval.comments.$params.required"
                                tip="Summarize in 1000 characters or less the approval decision."/>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-overlay :show="isProcessing" rounded opacity="0.6"
                                       spinner-small spinner-variant="primary"
                                       class="d-inline-block">
                                <b-button type="submit" variant="primary">
                                    Submit Approval Decision
                                </b-button>
                            </b-overlay>
                        </b-col>
                    </b-row>
                </b-form>
            </div>
        </div>
    </div>

    <form-summary :validator="$v.request" ref="errorContainer" id="errorContainer"/>

    <b-form>
        <b-row style="margin-bottom:18px;" v-if="!needsMyApproval && !needsMyICSApproval && isEditable">
            <b-col>
                <b-button type="button" variant="primary" v-if="!isEditing && isAssigned" @click="toggleEdit(false)">Edit Request</b-button>
                <b-button type="button" variant="outline-primary" v-if="allowAttachments && attachmentRequirements.length > 0" @click="toggleAttachments(false)">Add Attachment</b-button>
                <b-button type="button" variant="primary" v-if="isEditing" @click="saveEdits">Update Request</b-button>
                <b-button type="button" variant="outline-primary" v-if="isEditing" @click="toggleEdit(true)">Cancel Editing</b-button>
            </b-col>
        </b-row>

        <div class="card" header-bg-variant="primary" header-text-variant="white">
            <div class="card-header">Request Comments</div>
            <div class="card-body">
                <b-row>
                    <b-col>
                        <BaseTextOutput label="Current Pending PCN Update Request" :value="request.pcnUpdateComment"/>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <BaseTextOutput v-if="!isEditing" label="Comments" :value="request.comments"/>
                        <BaseParagraphInput v-model="request.comments"
                                            v-if="isEditing"
                                            :v="$v.request.comments"
                                            label="Edit Comment"
                                            slug="comments"
                                            tip=""/>
                    </b-col>
                </b-row>
            </div>
        </div>

        <div class="card" header-bg-variant="primary" header-text-variant="white"
             v-if="!_.includes(['10'], request.requestTypeValue.code)">
            <div class="card-header">Position Related Attributes from SEMA4/HR/Payroll system</div>
            <div class="card-body">
                <b-row>
                    <b-col cols="12" lg="12">
                        <b-button size="sm" v-on:click="getSema4AttributesOfCurrentPcn(request.positionNumber)"
                                  aria-label="pcn search button"
                                  v-b-toggle.collapse-3
                                  class="mb-4">Show/Hide Position Attributes
                        </b-button>
                        <b-collapse id="collapse-3" v-show="isShowingPcnAttributes">
                            <BaseSema4Attributes :pcn-sema4-attributes="pcnSema4Attributes[0]"
                                                 :funding-data="fundingData"
                            />
                        </b-collapse>

                    </b-col>

                </b-row>
            </div>

        </div>
        <div class="card" header-bg-variant="primary" header-text-variant="white">
            <div class="card-header">Attachments</div>
            <div class="card-body">
                <b-row>
                    <b-col cols="12" md="2" style="margin-bottom:8px;" v-if="isEditing || isEditingAttachments">
                        <FileAttachment
                                :id="this.request.id"
                                :requestType="request.requestTypeValue"
                                :requestStatus="request.requestStatusValue"
                                v-on:attachment-added="addAttachment"/>
                    </b-col>
                    <b-col v-if="request.requestTypeValue.description" cols="12" md="4">
                        <strong>{{ request.requestTypeValue.description }} requests require the following attachments:</strong>
                        <p v-for="item in requiredAttachments()" v-bind:key="item.value"
                           style="margin-left:11px; margin-top:8px;">
                      <span v-if="hasAttachment(item.value)">
                          <b-icon icon="check-circle" scale="1.75" variant="success"></b-icon>
                      </span>
                            <span v-else>
                          <b-icon icon="x-circle" scale="1.75" variant="danger"></b-icon>
                      </span>
                            <span style="margin-left:12px;">{{item.text}}</span>
                        </p>
                    </b-col>
                    <b-col>
                        <b-table hover small show-empty
                                 responsive="true"
                                 :fields="attachmentFields"
                                 :items="request.attachments"
                                 :busy="false">
                            <template v-slot:no-data>
                                No Attachments Found.
                            </template>
                            <div slot="table-busy" class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                            <template v-slot:cell(actions)="row">
                                <b-button size="sm" :href="row.item.openUrl" class="mr-1">
                                    view
                                </b-button>
                                <b-button size="sm" :href="row.item.url" target="_attach" class="mr-1">
                                    download
                                </b-button>
                                <b-button size="sm" variant="link" @click="removeAttachment(row.index, row.item)"
                                          v-if="isEditing">
                                    <b-icon icon="x-circle-fill" aria-hidden="true"></b-icon>
                                </b-button>
                            </template>
                            <template slot="empty" slot-scope="scope">
                                No Attachments Found.
                            </template>
                        </b-table>
                    </b-col>
                </b-row>
            </div>
        </div>


        <div class="card" header-bg-variant="primary" header-text-variant="white"
             v-if="!_.includes(['10'], request.requestTypeValue.code) ">
          <div class="card-header">Staffing Specialist Data Collected</div>
          <div class="card-body">
            <!--COMPLETE-->
            <div v-if="_.includes(['15'],request.requestStatusValue.code) && request.isComplete">
              <b-row>
                <b-col>
                  <BaseTextOutput :value="request.comments"
                                  label="Completed Comments"/>
                </b-col>
              </b-row>
              <hr/>
            </div>
            <!--BACKGROUND-->
            <div v-if="_.includes(['14','15'],request.requestStatusValue.code) && request.effectiveStartDate">
              <b-row>
                <b-col cols="12" lg="6">
                  <BaseTextOutput :value="request.backgroundRequestDate"
                                 label="Background Check Request Date"/>
                </b-col>
                <b-col cols="12" lg="6">
                  <BaseTextOutput :value="request.backgroundCompleteDate"
                                 label="Background Check Complete Date"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="6">
                  <BaseTextOutput label="Effective Start Date"
                                  :value="request.effectiveStartDate" v-if="!isEditing"/>
                  <BaseDateInput v-model="request.effectiveStartDate"
                                 :v="$v.request.effectiveStartDate"
                                 label="Effective Start Date"
                                 slug="start-date"
                                 v-if="isEditing"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <BaseTextOutput :value="request.backgroundCheckComments"
                                      label="Background Check Comments"/>
                </b-col>
              </b-row>
              <hr/>
            </div>
            <!--OFFERED-->
            <div v-if="_.includes(['13','14','15', '36'],request.requestStatusValue.code) && request.contingentOfferMadeDate">
              <b-row>
                <b-col cols="12" lg="6">
                  <BaseTextOutput :value="request.contingentOfferMadeDate"
                                 label="Contingent Offer Made Date"/>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" lg="6">
                  <BaseTextOutput :value="request.offerAcceptanceDate"
                                 label="Offer Acceptance Date"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <BaseTextOutput :value="request.offerComments"
                                      label="Offered Comments"/>
                </b-col>
              </b-row>
              <hr/>
            </div>
            <!-- MAKE OFFER -->
            <div v-if="request.offerMethod">
               <b-row v-show="request.offerMethod">
                  <b-col cols="2">
                    <BaseTextOutput label="Offer Method"
                                    :value="request.offerMethod"/>
                    </b-col>
                    <b-col cols="2">
                    <BaseTextOutput label="Contingent Offer Made"
                                    :value="request.contingentOfferMadeDate"/>
                    </b-col>
                  <b-col cols="2">
                    <BaseTextOutput label="Offer Outcome"
                                    :value="request.offerOutcome"/>
                  </b-col>
                  <b-col cols="2">
                    <BaseTextOutput label="Offer Decline Reason"
                                    :value="request.offerDeclineReason"/>
                  </b-col>
                  <b-col cols="2">
                    <BaseTextOutput label="Offer Next Steps"
                                    :value="request.offerNextStep"/>
                  </b-col>
                  <b-col cols="6" v-show="request.offerOtherText">
                    <BaseTextOutput label="Offer Other Comments"
                                    :value="request.offerOtherText"/>
                  </b-col>
              </b-row>
              <hr/>
            </div>
            <!--SALARY REVIEW-->
            <div v-if="(_.includes(['12','13','14','15', '36'],request.requestStatusValue.code) && request.compJustificationDocumentation) || reofferReasonString !== ''">
              <b-row>
                <b-col cols="12" lg="3">
                  <BaseTextOutput :value="salaryApprovedDate"
                                  label="Salary Approved Date"/>
                </b-col>
                <b-col cols="12" lg="3">
                  <BaseTextOutput :value="salaryApprovedBy"
                                  label="Salary Approved By"/>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" lg="3">
                  <BaseTextOutput :value="request.approvedSalaryRecommendation"
                                label="Approved Salary Recommendation"/>
                </b-col>
                <b-col cols="12" lg="3">
                  <BaseTextOutput :value="request.approvedStep"
                                 label="Approved Step"/>
                </b-col>
                <b-col cols="12" lg="3">
                  <BaseTextOutput :value="request.approvedRate"
                                  label="Approved Rate"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="3">
                  <BaseTextOutput :value="request.amountOfChange"
                                 label="Approved Amount of Change"/>
                </b-col>
                <b-col cols="12" lg="3">
                  <BaseTextOutput :value="request.approvedAmountOfChangeUom"
                                label="Approved Amount of Change Unit of Measure"/>
                </b-col>
                <b-col cols="12" lg="6">
                  <BaseTextOutput :value="request.salaryApprovalComments"
                                label="Salary Approval Comments"/>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" lg="12">
                  <b-button v-b-toggle.collapse-2 class="mb-4" size="sm">
                    Show Recommendations Prior to Approval
                  </b-button>
                </b-col>
              </b-row>

              <b-collapse id="collapse-2">
                <b-card>
                <b-row>
                  <b-col cols="12" lg="3">
                    <BaseTextOutput :value="request.compJustificationDocumentation"
                                  label="Salary Recommendation"/>
                  </b-col>
                  <b-col cols="12" lg="3">
                    <BaseTextOutput :value="request.step"
                                  label="Recommended Step"/>
                  </b-col>
                  <b-col cols="12" lg="3">
                    <BaseTextOutput :value="request.rate"
                                    label="Recommended Rate"/>
                  </b-col>
                  <b-col cols="12" lg="3">
                    <BaseTextOutput :value="request.hiringAction"
                                  label="Type of Hire"/>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="12" lg="3">
                    <BaseTextOutput :value="request.amountOfChange"
                                  label="Recommended Amount of Change"/>
                  </b-col>
                  <b-col cols="12" lg="3">
                    <BaseTextOutput :value="request.amountOfChangeUom"
                                  label="Recommended Amount of Change Unit of Measure"/>
                  </b-col>
                  <b-col cols="12" lg="3">
                    <BaseTextOutput :value="request.recommendedSalaryWithinDDDelegation === true ? 'Yes' : 'No'"
                                  label="Is Recommended salary within division director delegation?"/>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="12" lg="3">
                    <BaseTextOutput :value="request.currentClassification"
                                  label="Former/Current Classification"/>
                  </b-col>
                  <b-col cols="12" lg="3">
                    <BaseTextOutput :value="request.currentCompCode"
                                  label="Former/Current Comp Code"/>
                  </b-col>
                  <b-col cols="12" lg="3">
                    <BaseTextOutput :value="request.currentStep"
                                  label="Former/Current Step"/>
                  </b-col>
                  <b-col cols="12" lg="3">
                    <BaseTextOutput :value="request.currentRate"
                                    label="Former/Current Rate"/>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" lg="3">
                    <BaseTextOutput :value="request.eligibilityNextProgressIncreaseDate"
                                  label="Date of Eligibility for next progression increase"/>
                  </b-col>
                  <b-col cols="12" lg="9">
                    <BaseTextOutput :value="request.hrInternalEquityComparisonAnalysis"
                                  label="HR Internal Equity and Comparison Analysis"/>
                  </b-col>
                </b-row>
                </b-card>
              </b-collapse>

              <b-row>
                <b-col cols="12" lg="3">
                  <BaseTextOutput label="Selected Candidate Name"
                                  :value="request.selectedCandidateName" v-if="!isEditing"/>
                  <BaseTextInput v-model="request.selectedCandidateName"
                                 :v="$v.request.selectedCandidateName"
                                 label="Selected Candidate Name"
                                 tip=""
                                 v-if="isEditing"
                                 slug="candidateName"/>
                </b-col>
                <b-col cols="12" lg="3">
                  <BaseTextOutput label="Selected Candidate Email"
                                  :value="request.selectedCandidateEmail" v-if="!isEditing"/>
                  <BaseTextInput v-model="request.selectedCandidateEmail"
                                 :v="$v.request.selectedCandidateEmail"
                                 label="Selected Candidate Email"
                                 tip=""
                                 v-if="isEditing"
                                 slug="candidateEmail"/>
                </b-col>
                <b-col cols="12" lg="3">
                  <BaseTextOutput label="Selected Candidate Employee ID"
                                  :value="request.selectedCandidateEmployeeId" v-if="!isEditing"/>
                  <BaseTextInput v-model="request.selectedCandidateEmployeeId"
                                 :v="$v.request.selectedCandidateEmployeeId"
                                 label="Selected Candidate Employee ID"
                                 tip=""
                                 v-if="isEditing"
                                 slug="candidateEmpId"/>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" lg="4">
                  <BaseTextOutput label="FLSA Status"
                                  :value="translate(request.flsaStatusValue)"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <BaseTextOutput :value="request.salaryComments"
                                      label="Salary Review Comments"/>
                </b-col>
                <b-col>
                  <BaseTextOutput :value="reofferReasonString"
                                  label="Reasons offer is reoffered to a different candidate"/>
                </b-col>

              </b-row>
              <hr/>
            </div>
            <!--PRE OFFER-->
            <div v-if="_.includes(['11','12','13','14','15', '36'],request.requestStatusValue.code)">
              <b-row>
                <b-col>
                  <BaseTextOutput :value="request.preofferComments"
                                      label="Pre Offer Review Comments"/>
                </b-col>
              </b-row>
              <hr/>
            </div>
            <!--MANAGER INTERVIEW-->
            <div v-if="_.includes(['11','12','13','14','15','16', '36'],request.requestStatusValue.code)">
              <b-row v-if="!request.compJustificationDocumentation">
                <b-col cols="12" lg="4">
                  <BaseTextOutput label="Selected Candidate Name"
                                  :value="request.selectedCandidateName" v-if="!isEditing"/>
                  <BaseTextInput v-model="request.selectedCandidateName"
                                 :v="$v.request.selectedCandidateName"
                                 label="Selected Candidate Name"
                                 tip=""
                                 v-if="isEditing"
                                 slug="candidateName"/>
                </b-col>
                <b-col cols="12" lg="4">
                  <BaseTextOutput label="Selected Candidate Email"
                                  :value="request.selectedCandidateEmail" v-if="!isEditing"/>
                  <BaseTextInput v-model="request.selectedCandidateEmail"
                                 :v="$v.request.selectedCandidateEmail"
                                 label="Selected Candidate Email"
                                 tip=""
                                 v-if="isEditing"
                                 slug="candidateEmail"/>
                </b-col>
                <b-col cols="12" lg="4">
                  <BaseTextOutput label="Selected Candidate Employee ID"
                                  :value="request.selectedCandidateEmployeeId" v-if="!isEditing"/>
                  <BaseTextInput v-model="request.selectedCandidateEmployeeId"
                                 :v="$v.request.selectedCandidateEmployeeId"
                                 label="Selected Candidate Employee ID"
                                 tip=""
                                 v-if="isEditing"
                                 slug="candidateEmpId"/>
                </b-col>
              </b-row>
              <b-row v-if="request.interviewComments">
                <b-col>
                  <BaseTextOutput :value="request.interviewComments"
                                      label="Manager Interview Comments"/>
                </b-col>
              </b-row>

            </div>
            <!--SCREEN APPLICANT-->
            <div v-if="_.includes(['10','11','12','13','14','15','16', '36'],request.requestStatusValue.code)">
              <b-row>
                <b-col cols="12">
                  <BaseTextOutput label="DD-214 Received Date"
                                  :value="request.dd14ReceivedDate" v-if="!isEditing"/>
                  <BaseDateInput v-model="request.dd14ReceivedDate"
                                 :v="$v.request.dd14ReceivedDate"
                                 label="DD-214 Received Date"
                                 slug="dd14-date"
                                 v-if="isEditing"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <BaseTextOutput :value="request.screeningComments"
                                      label="Screen Applicant Comments"/>
                </b-col>
              </b-row>
              <hr/>
            </div>
            <!--POSTED-->
            <div v-if="_.includes(['09','10','11','12','13','14','15','16', '36'],request.requestStatusValue.code)">
              <b-row>
                <b-col cols="12" lg="4">
                  <BaseTextOutput :value="request.postingOpenDate"
                                 label="Posting Open Date"/>
                </b-col>
                <b-col cols="12" lg="4">
                  <BaseTextOutput :value="request.postingCloseDate"
                                 label="Posting Close Date"/>
                </b-col>
                <b-col cols="12" lg="4">
                  <BaseTextOutput :value="request.howPosted"
                                 label="How Posted"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <BaseTextOutput :value="request.postingComments"
                                      label="Posted Comments"/>
                </b-col>
              </b-row>
              <hr/>
            </div>
            <!--DRAFT POSTING-->
            <div v-if="_.includes(['08','09','10','11','12','13','14','15','16', '36'],request.requestStatusValue.code)">
               <b-row>
                <b-col>
                  <BaseTextOutput label="Recruiting Solutions Job ID"
                                  :value="request.jobId" v-if="!isEditing"/>
                  <BaseTextInput v-model="request.jobId"
                                 :v="$v.request.jobId"
                                 slug="jobId"
                                 label="Recruiting Solutions Job ID"
                                 v-if="isEditing"/>
                </b-col>
                 <b-col>
                   <BaseTextOutput label="Position Control Number" :value="request.positionNumber"/>
                 </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <BaseTextOutput :value="request.draftPostingComments"
                                      label="Draft Posting Comments"/>
                </b-col>
              </b-row>
              <hr/>
            </div>
            <!--AUDIT-->
            <div v-if="_.includes(['07','08','09','10','11','12','13','14','15','16', '36'],request.requestStatusValue.code)">
              <b-row v-if="request.audit.auditCheckedBy">
                <b-col cols="12" lg="4">
                  <BaseTextOutput :value="auditApprovedDate"
                                  label="Audit Approved Date"/>
                </b-col>
                <b-col cols="12" lg="4">
                  <BaseTextOutput :value="request.audit.auditCheckedBy.userId"
                                  label="Audit Approved By"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="4">
                  <BaseTextOutput :value="request.audit.unclassifiedType"
                                  label="Unclassified Type"/>
                </b-col>
                <b-col v-if="request.audit.otherUnclassifiedType" cols="12" lg="4">
                  <BaseTextOutput :value="request.audit.otherUnclassifiedType"
                                  label="Other Statutory"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <BaseTextOutput :value="request.audit.auditFinalClassification"
                                  label="Final Classification"/>
                </b-col>

                <b-col>
                  <BaseTextOutput :value="request.audit.auditFinalClassOption"
                                  label="Final Class Option"/>
                </b-col>

                <b-col>
                  <BaseTextOutput :value="request.audit.jobCode"
                                 label="Job Code"/>
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <BaseTextOutput :value="request.audit.auditComments"
                                  label="Audit Comments"/>
                </b-col>
              </b-row>
              <hr/>
            </div>
            <!--ASSIGNED-->
            <div v-if="_.includes(['06','07','08','09','10','11','12','13','14','15','16', '36'],request.requestStatusValue.code)">
              <b-row>
                <b-col cols="12" lg="4">
                  <BaseTextOutput :value="request.priority" v-if="!isEditing"
                                  label="Request Priority"/>
                  <BaseSelector v-model="request.priority"
                                :v="$v.request.priority"
                                label="Request Priority"
                                slug="priority"
                                :options=priorityOptions
                                v-if="isEditing"
                                tip="Determined with Division" />
                </b-col>
                <b-col cols="12" lg="4">
                  <BaseTextOutput :value="request.preHireConsultDate"
                                  label="Pre Hire Consult Date"/>
                </b-col>
                <b-col cols="12" lg="4">
                  <BaseTextOutput :value="translateBU(request.bargainingUnit)" v-if="!isEditing"
                                  label="Bargaining Unit"/>
                  <BaseSelector v-model="request.bargainingUnit"
                                :v="$v.request.bargainingUnit"
                                label="Bargaining Unit"
                                slug="bargainingUnit"
                                :options=bargainingUnitOptions
                                v-if="isEditing"
                                tip="" />
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12">
                  <BaseTextOutput :value="request.assignmentComments"
                                  label="Assignment Comments"/>
                </b-col>
              </b-row>
            </div>

            <!-- Payroll Separation -->
            <div v-if="_.includes(['32'],request.requestStatusValue.code)">
              <b-row>
                <b-col cols="12" lg="4">
                    <BaseTextOutput label="Employee Name" :value="request.employee.name + ' - ' + request.employee.employeeId + ' - ' + request.employee.pcn"/>
                </b-col>
                <b-col cols="12" lg="4">
                  <BaseTextOutput :value="request.bargainingUnit" label="Bargaining Unit"/>
                </b-col>
                <b-col cols="12" lg="4">
                  <BaseTextOutput :value="request.lastWorkedDate" label="Last Day Worked"/>
                </b-col>
                <b-col cols="12" lg="4">
                  <BaseTextOutput :value="request.payPeriodEndingDate" label="Last Day Worked"/>
                </b-col>
                <b-col cols="12" lg="4">
                  <BaseTextOutput :value="request.separationType" label="Last Day Worked"/>
                </b-col>
                <b-col cols="12" lg="4">
                  <BaseTextOutput :value="request.rate" label="Hourly Rate"/>
                </b-col>
                <b-col cols="12" lg="4">
                  <BaseTextOutput :value="request.vacationElig" label="Vacation Eligible?"/>
                </b-col>
                <b-col cols="12" lg="4">
                  <BaseTextOutput :value="request.vacationHours" label="Vacation Amount ($)"/>
                </b-col>   
                <b-col cols="12" lg="4">
                  <BaseTextOutput :value="request.vacationPayoutType" label="Vacation Payout Type"/>
                </b-col>                   
                <b-col cols="12" lg="4">
                  <BaseTextOutput :value="request.severanceElig" label="Severance Eligible?"/>
                </b-col>                            
                <b-col cols="12" lg="4">
                  <BaseTextOutput :value="request.severancePayout" label="Severance Amount ($)"/>
                </b-col>      
                <b-col cols="12" lg="4">
                  <BaseTextOutput :value="request.severancePayoutType" label="Severance Payout Type"/>
                </b-col>      
                <b-col cols="12" lg="4">
                  <BaseTextOutput :value="request.healthCareRetirement" label="Health Care Retirement"/>
                </b-col>                                                                            
                <b-col cols="12" lg="4">
                  <BaseTextOutput :value="request.compPayout" label="Comp Payout Hours"/>
                </b-col>      
                <b-col cols="12" lg="4">
                  <BaseTextOutput :value="request.removeSick" label="Remove Sick Hours (SIK)"/>
                </b-col>                                      
              </b-row>

              <b-row>
                <b-col cols="12">
                  <BaseTextOutput :value="request.assignmentComments"
                                  label="Assignment Comments"/>
                </b-col>
              </b-row>
            </div>

          </div>
        </div>

        <div class="card" header-bg-variant="primary" header-text-variant="white"
            v-if="!_.includes(['10'], request.requestTypeValue.code)">
            <div class="card-header">Position Information</div>
            <div class="card-body">
                <b-row>
                    <b-col cols="12" lg="6">
                        <BaseTextOutput label="Request Type" :value="request.requestTypeValue.description" v-if="!isEditing"/>
                        <BasePositionStatus v-model="request.requestTypeValue" v-if="isEditing"
                                    :v="$v.request.requestTypeValue"
                                    :key="keys.requestType"
                                    label="Request Type"
                                    slug="requestType"
                                    tip="What type of request is being submitted. Based on type selected different form options are displayed."/>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Position Control Number" :value="request.positionNumber" v-if="!isEditing"/>
                        <BaseTextInput v-model="request.positionNumber" v-if="isEditing"
                                    :v="$v.request.positionNumber"
                                    label="Position Control Number"
                                    tip="Should be 8 digits. Use leading zeroes as needed. If new/unknown enter 00000000."
                                    v-on:change.native="padPositionNumber"
                                    slug="pcn"
                                    :plaintext=!isEditing
                                    :required="$v.$params.required"/>
                    </b-col>

                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Previous Incumbent" :value="request.previousIncumbent" v-if="!isEditing"/>
                        <BaseTextInput v-model="request.previousIncumbent" v-if="isEditing"
                                   :v="$v.request.previousIncumbent"
                                   label="Previous Incumbent"
                                   slug="previousEmployee"
                                   tip="If any."/>
                    </b-col>

                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Proposed Classification" :value="request.proposedClassification" v-if="!isEditing"/>
                      <BaseClassificationSelector v-model="request.proposedClassification" v-if="isEditing"
                                                  :v="$v.request.proposedClassification"
                                                  slug="classification"
                                                  label="Proposed Classification"
                                                  sr="Search for Proposed Classification"
                                                  :required="$v.request.proposedClassification.$params.required ? true : false"/>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Class Option" :value="request.classOption" v-if="!isEditing"/>
                        <BaseTextInput v-model="request.classOption"
                            v-if="isEditing"
                            :v="$v.request.classOption"
                            slug="classOption"
                            label="Class Option"/>
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Appointment Type"
                            :value="_.get(request, 'appointmentValue.description', '')" v-if="!isEditing"/>
                        <BaseSelector v-model="request.appointmentValue.code" v-if="isEditing"
                              :v="$v.request.appointmentValue.code"
                              label="Appointment Type"
                              slug="appointmentType"
                              :options = appointmentTypeOptions />
                    </b-col>

                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Classified or Unclassified"
                            :value="request.positionClassificationValue.description" v-if="!isEditing"/>
                        <BaseSelector v-model="request.positionClassificationValue.code" v-if="isEditing"
                              :v="$v.request.positionClassificationValue.code"
                              label="Classified or Unclassified"
                              slug="classifiedType"
                              :options = positionClassificationOptions />
                    </b-col>

                </b-row>

                <b-row>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Working Title" :value="request.workingTitle" v-if="!isEditing"/>
                        <BaseTextInput v-model="request.workingTitle"
                            v-if="isEditing"
                            :v="$v.request.workingTitle"
                            slug="workingTitle"
                            label="Working Title"/>
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Employment Condition" v-if="!isEditing"
                            :value="request.positionScheduleValue.description"/>
                        <BaseSelector v-model="request.positionScheduleValue.code"
                            v-if="isEditing"
                            :v="$v.request.positionScheduleValue.code"
                            label="Employment Condition"
                            :options = positionScheduleOptions />
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Position Location" :value="request.positionLocation" v-if="!isEditing"/>
                        <BaseLocationSelector v-model="request.positionLocation"  v-if="isEditing"
                                      :v="$v.request.positionLocation"
                                      :key="keys.location"
                                      v-on:input='forceLocationRerender'
                                      slug="location"
                                      cid="l1"
                                      label="Position Location"/>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Travel Requirement" :value="request.workTravelValue.description" v-if="!isEditing"/>
                        <BaseSelector v-model="request.workTravelValue.code" v-if="isEditing"
                              :v="$v.request.workTravelValue.code"
                              label="Travel Requirement"
                              slug="travel"
                              :options = workTravelOptions />
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Hours Per Week" :value="request.hoursPerWeek" v-if="!isEditing"/>
                        <BaseTextInput v-model="request.hoursPerWeek" v-if="isEditing"
                                    :v="$v.request.hoursPerWeek"
                                    label="Hours Per Week"
                                    slug="stdHours"
                                    tip="Hours per week cannot be more than 40"/>
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Work Hours" :value="request.workingHours" v-if="!isEditing"/>
                        <BaseTextInput v-model="request.workingHours" v-if="isEditing"
                                    :v="$v.request.workingHours"
                                    label="Work Hours"
                                    slug="workingHours"
                                    tip="Example: 8:00 am - 4:30 pm"/>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Work Schedule" :value="request.workScheduleValue.description" v-if="!isEditing"/>
                        <BaseSelector v-model="request.workScheduleValue.code" v-if="isEditing"
                                    :v="$v.request.workScheduleValue.code"
                                    label="Work Schedule"
                                    slug="schedule"
                                    tip=""
                                    :options = workScheduleOptions />
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Anticipated Start Date" :value="request.anticipatedStartDate" v-if="!isEditing"/>
                      <BaseDateInput v-model="request.anticipatedStartDate" v-if="isEditing"
                                     :v="$v.request.anticipatedStartDate"
                                     label="Anticipated Start Date"
                                     slug="start-date"
                                     :required="true"/>
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="End Date" :value="request.endDate" v-if="!isEditing"/>
                        <b-form-group label="End Date" label-for="end-input" v-if="isEditing">
                            <date-picker id="end-input" v-model="request.endDate"
                                        data-test="end-date"
                                        :config="options">
                            </date-picker>
                            <b-form-text id="end-input-help">Format: YYYY-MM-DD.</b-form-text>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row v-if="request.appointmentValue.code && request.appointmentValue.code === 'N'">
                  <b-col cols="12">
                  <BaseTextOutput label="Explain why the position is time-limited (cannot be based on funding alone)" :value="request.timeLimitedReason" />
                  </b-col>
                  <b-col cols="12">
                  <BaseTextOutput label="If work completed earlier than expected, is the intent to end incumbent''s position immediately?" :value="request.endWhenWorkComplete" />
                  </b-col>
                  <b-col cols="12">
                  <BaseTextOutput label="Summary of purpose/primary role of the position and primary clientele, if any" :value="request.purposeOfPosition" />
                  </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Job Code" :value="request.audit.jobCode ? request.audit.jobCode : 'not provided'" />
                    </b-col>
                </b-row>
            </div>
        </div>

        <div class="card" header-bg-variant="primary" header-text-variant="white"
            v-if="_.includes(['09'], request.requestTypeValue.code)">
            <div class="card-header">Redeployment/Re-assignment Information</div>
            <div class="card-body">

                <b-row>
                    <b-col cols="12" lg="6">
                        <BaseTextOutput label="COOP Level" :value="request.coopLevel" v-if="!isEditing"/>
                        <BaseSelector v-model="request.coopLevel" v-if="isEditing"
                            :v="$v.request.coopLevel"
                            label="COOP Level of Position"
                            slug="coop"
                            :options = coopOptions />
                    </b-col>

                    <b-col cols="12" lg="6">
                        <BaseTextOutput label="Employment Condition" :value="request.positionScheduleValue.description" v-if="!isEditing"/>
                         <BaseSelector v-model="request.positionScheduleValue.code" v-if="isEditing"
                            :v="$v.request.positionScheduleValue.code"
                            label="Employment Condition"
                            slug="fte"
                            :options = positionScheduleOptions />
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Hours Per Week" :value="request.hoursPerWeek" v-if="!isEditing"/>
                        <BaseTextInput v-model="request.hoursPerWeek" v-if="isEditing"
                            :v="$v.request.hoursPerWeek"
                            label="Hours Per Week"
                            slug="stdHours"
                            tip="Hours per week cannot be more than 40"/>
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Work Schedule" :value="request.workScheduleValue.description" v-if="!isEditing"/>
                         <BaseSelector v-model="request.workScheduleValue.code" v-if="isEditing"
                            :v="$v.request.workScheduleValue.code"
                            label="Work Schedule"
                            slug="schedule"
                            tip=""
                            :options = workScheduleOptions />
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Position Location" :value="request.positionLocation" v-if="!isEditing"/>
                        <BaseLocationSelector v-model="request.positionLocation" v-if="isEditing"
                            :v="$v.request.positionLocation"
                            :required="$v.request.positionLocation.$params.required ? true : false"
                            slug="location"
                            cid="l2"
                            label="Position Location"/>
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Travel Requirement" :value="request.workTravelValue.description" v-if="!isEditing"/>
                        <BaseSelector v-model="request.workTravelValue.code" v-if="isEditing"
                        :v="$v.request.workTravelValue.code"
                        label="Travel Requirement"
                        slug="travel"
                        :options = workTravelOptions />
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Driver's License Required" :value="request.dlRequired" v-if="!isEditing"/>
                        <BaseSelector v-model="request.dlRequired" v-if="isEditing"
                        :v="$v.request.dlRequired"
                        label="Driver's License Required"
                        slug="dlrequired"
                        :options = yesNoOptions />
                    </b-col>
                    <b-col cols="12" lg="4" v-show="false">
                        <BaseTextOutput label="Employee is Available to Telework" :value="request.teleworkAvailable" v-if="!isEditing"/>
                        <BaseSelector v-model="request.teleworkAvailable" v-if="isEditing"
                        :v="$v.request.teleworkAvailable"
                        label="Employee is Available to Telework"
                        slug="telework"
                        :options = yesNoUnknownOptions />
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" lg="4">
                      <BaseTextOutput label="Anticipated Start Date" :value="request.anticipatedStartDate" v-if="!isEditing"/>
                      <BaseDateInput v-model="request.anticipatedStartDate" v-if="isEditing"
                                     :v="$v.request.anticipatedStartDate"
                                     label="Anticipated Start Date"
                                     slug="start-date"
                                     :required="true"/>
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="End Date" :value="request.endDate" v-if="!isEditing"/>
                      <BaseDateInput v-model="request.endDate" v-if="isEditing"
                                     :v="$v.request.endDate"
                                     label="End Date"
                                     slug="end-date"
                                     :required="false"/>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12">
                        <BaseTextOutput label="Required Skill Set" :value="request.skillSet" v-if="!isEditing"/>
                        <b-form-group label="Required Skill Set" v-if="isEditing">
                            <b-form-checkbox-group
                            stacked
                            v-model="selectedSkills"
                            :options="skillSetOptions"
                            name="skillSet"
                            value-field="value"
                            text-field="text">
                            </b-form-checkbox-group>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <BaseTextOutput label="Other Required Skill" :value="request.otherSkillSet" v-if="!isEditing"/>
                        <BaseTextInput v-model="request.otherSkillSet" v-if="isEditing"
                            :v="$v.request.otherSkillSet"
                            label="Other Skill Set"
                            slug="otherSkillSet"/>
                    </b-col>
                </b-row>
            </div>
        </div>
        <div class="card" header-bg-variant="primary" header-text-variant="white"
            v-if="_.includes(['10'], request.requestTypeValue.code) && (hasLeaveRole || hasTransactionRole || hasPayrollRole) ">
            <div class="card-header">Leave Request</div>
            <div class="card-body">
                <b-row>
                    <b-col cols="12" lg="12">
                        <div v-if="!isEditing">
                            <b-row>
                                <b-col cols="12" lg="4">
                                    <BaseTextOutput label="Employee Name" :value="request.employee.name"/>
                                </b-col>
                                <b-col cols="12" lg="4">
                                    <BaseTextOutput label="Employee Email" :value="request.employee.email"/>
                                </b-col>
                                <b-col cols="12" lg="4">
                                    <BaseTextOutput label="Employee ID" :value="request.employee.employeeId"/>
                                </b-col>
                            </b-row>
                        </div>
                        <BaseEmployeeSelector v-model="request.employee" v-if="isEditing"
                            label="Employee"
                            :v="$v.request.employee"
                            slug="employee"
                            tip=""
                            :showPcn="true"/>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Leave Type" :value="request.leaveType" v-if="!isEditing"/>
                         <BaseSelector v-model="request.leaveType" v-if="isEditing"
                            :v="$v.request.leaveType"
                            label="Leave Type"
                            :key="keys.leaveType"
                            v-on:input='changeLeaveTypeOptionsAndClear'
                            slug="leaveType"
                            :options = leaveTypeOptions />
                    </b-col>
                     <b-col cols="12" lg="4" v-if="false">
                        <BaseTextOutput label="Employee is Available to Telework" :value="request.teleworkAvailable" v-if="!isEditing"/>
                        <BaseSelector v-model="request.teleworkAvailable" v-if="isEditing"
                            :v="$v.request.teleworkAvailable"
                            label="Employee is Available to Telework"
                            slug="telework"
                            :options = yesNoUnknownOptions />
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Employment Condition" :value="request.positionScheduleValue.description" v-if="!isEditing"/>
                        <BaseSelector v-model="request.positionScheduleValue.code" v-if="isEditing"
                            :v="$v.request.positionScheduleValue.code"
                            label="Employment Condition"
                            slug="fte"
                            :options = positionScheduleOptions />
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Date Request Received" :value="request.leaveRequestReceived" v-if="!isEditing"/>
                        <BaseDateInput v-model="request.leaveRequestReceived" v-if="isEditing"
                            :v="$v.request.leaveRequestReceived"
                            label="Date Request Received"
                            slug="leaveRequestRecd" />
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Anticipated Start Date" :value="request.anticipatedStartDate"
                            v-if="!isEditing"/>
                        <BaseDateInput v-model="request.anticipatedStartDate" v-if="isEditing"
                            :v="$v.request.anticipatedStartDate"
                            label="Anticipated Start Date"
                            slug="start-date"/>
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="End Date" :value="request.endDate" v-if="!isEditing"/>
                        <BaseDateInput v-model="request.endDate" v-if="isEditing"
                            :v="$v.request.endDate"
                            label="Anticipated End Date"
                            slug="end-date"/>
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Certification Deadline" :value="request.certificationDeadline" v-if="!isEditing"/>
                        <BaseDateInput v-model="request.certificationDeadline" v-if="isEditing"
                            :v="$v.request.certificationDeadline"
                            label="Certification Deadline"
                            slug="certificationDeadline" />
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Type of Leave"
                            :value="request.typeOfCovidLeave ? request.typeOfCovidLeave  : '--' "
                            v-if="!isEditing"/>
                        <BaseSelector v-model="request.typeOfCovidLeave" v-if="isEditing"
                            :v="$v.request.typeOfCovidLeave"
                            label="Type of Leave"
                            slug="covidLeave"
                            :options = leaveTypeSubOptions />
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Reason for FMLA/LOA"
                            :value="request.fmlaReason ? request.fmlaReason : '--' "
                            v-if="!isEditing"/>
                        <BaseSelector v-model="request.fmlaReason" v-if="isEditing"
                            :v="$v.request.fmlaReason"
                            label="Reason for FMLA/LOA"
                            slug="fmlaReason"
                            :options = fmlaReasonsOptions />
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Date FMLA MedCert Rec'd" :value="request.medCertReceived" v-if="!isEditing"/>
                        <BaseDateInput v-model="request.medCertReceived" v-if="isEditing"
                            :v="$v.request.medCertReceived"
                            label="Date FMLA MedCert Rec'd"
                            slug="medCertDate" />
                    </b-col>
                </b-row>

                <b-row>
                     <b-col cols="12" lg="4">
                        <BaseTextOutput label="Work Status"
                            :value="request.workStatus ? request.workStatus : '--' " v-if="!isEditing"/>
                        <BaseSelector v-model="request.workStatus" v-if="isEditing"
                            :v="$v.request.workStatus"
                            label="Work Status"
                            slug="workStatus"
                            :options = workStatusOptions />
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="PT Leave Needs"
                            :value="request.ptLeaveNeeds ? request.ptLeaveNeeds : '--' " v-if="!isEditing"/>
                        <BaseTextInput v-model="request.ptLeaveNeeds" v-if="isEditing"
                            :v="$v.request.ptLeaveNeeds"
                            label="PT Leave Needs"
                            slug="ptLeaveNeeds" />
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Number of Cases"
                            :value="request.nbrCases ? request.nbrCases : '--' " v-if="!isEditing"/>
                        <BaseTextInput v-model="request.nbrCases" v-if="isEditing"
                            :v="$v.request.nbrCases"
                            label="Number of Cases"
                            slug="nbrCases" />
                    </b-col>
                </b-row>

                <b-row v-if="hasLeaveRole">
                     <b-col cols="12" lg="4">
                        <label>Is Employee on Probation</label><br/>
                        <b-form-checkbox
                            v-model="request.onProbation"
                            :v="$v.request.onProbation"    
                            name="probation">
                            Yes
                        </b-form-checkbox>
                    </b-col>
                    <b-col cols="12" lg="4">
                        <label>Parenthood Leave Concurrent</label><br/>
                        <b-form-checkbox
                            v-model="request.parenthoodLeaveConcurrent"
                            :v="$v.request.parenthoodLeaveConcurrent"    
                            name="parenthoodLeaveConcurrent">
                            Yes
                        </b-form-checkbox>
                    </b-col>
                </b-row>
                <b-row v-if="hasTransactionRole || hasPayrollRole">
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Is Employee on Probation" :value="request.onProbation ? 'Yes' : 'No'"/>
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Parenthood Leave Concurrent" :value="request.parenthoodLeaveConcurrent ? 'Yes' : 'No'"/>
                        <label></label><br/>
                    </b-col>
                </b-row>


                <b-row>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Leave Decision"
                            :value="request.leaveDecision ? request.leaveDecision : '--'" v-if="!isEditing"/>
                        <BaseSelector v-model="request.leaveDecision" v-if="isEditing"
                            :v="$v.request.leaveDecision"
                            label="Leave Decision"
                            slug="leaveDecision"
                            v-on:input='forceDenialRerender'
                            :options = leaveDecisionOptions />
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="COVID Leave hours used"
                            :value="request.covidLeaveHrsUsed ? request.covidLeaveHrsUsed : '--' " v-if="!isEditing"/>
                        <BaseTextInput v-model="request.covidLeaveHrsUsed" v-if="isEditing"
                            :v="$v.request.covidLeaveHrsUsed"
                            label="COVID Leave hours used"
                            tip="hours"
                            slug="covid-leave-hrs"/>
                    </b-col>

                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Eligible for EFMLA?"
                            :value="request.efmlaHrs ? request.efmlaHrs : '--' " v-if="!isEditing"/>
                        <BaseSelector v-model="request.efmlaHrs" v-if="isEditing"
                            :v="$v.request.efmlaHrs"
                            label="Eligible for EFMLA"
                            :options="yesNoOptions"/>
                    </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" lg="4">
                    <BaseTextOutput label="Effective Start Date" :value="request.effectiveStartDate"
                                    v-if="!isEditing"/>
                    <BaseDateInput v-model="request.effectiveStartDate" v-if="isEditing"
                                   :v="$v.request.effectiveStartDate"
                                   label="Effective Start Date"
                                   slug="effective-start-date"/>
                  </b-col>
                  <b-col cols="12" lg="4">
                    <BaseTextOutput label="Effective End Date" :value="request.effectiveEndDate"
                                    v-if="!isEditing"/>
                    <BaseDateInput v-model="request.effectiveEndDate" v-if="isEditing"
                                   :v="$v.request.effectiveEndDate"
                                   label="Effective End Date"
                                   slug="effective-end-date"/>
                  </b-col>
                  <b-col cols="12" lg="4">
                    <BaseTextOutput label="Leave Hours"
                                    :value="request.leaveHours" v-if="!isEditing"/>
                    <BaseTextInput v-model="request.leaveHours" v-if="isEditing"
                                   :v="$v.request.leaveHours"
                                   label="Leave Hours"
                                   slug="leave-hours"/>
                  </b-col>
                </b-row>
                <b-row v-if="request.leaveDecision === 'Denied'">
                    <b-col>
                        <BaseTextOutput label="Denial Reason" :value="request.denialReason ? request.denialReason : '--'"
                            v-if="!isEditing"/>
                        <BaseParagraphInput v-model="request.denialReason"
                            v-if="isEditing"
                            :v="$v.request.denialReason"
                            :key="keys.denial"
                            label="Denial Reason"
                            slug="denialReason"
                            tip=""/>
                    </b-col>
                </b-row>


                <b-row v-if="isEditing">
                    <b-col cols="4" v-if="request.requestStatusValue.code === '02'">
                         <BaseSwitchInput v-model="request.isLeaveRequestClosed"
                                :v="$v.request.isLeaveRequestClosed"
                                label="Is Leave Request Closed?"
                                :disabled="request.isLeaveRequestClosed"
                                tip=""/>
                    </b-col>
                    <b-col cols="4" v-if="_.includes(['01','02'],request.requestStatusValue.code) && request.leaveDecision === 'Approved' ">
                      <b-form-checkbox
                          v-model="transactionPPL"
                          :v="$v.transactionPPL"
                          name="probation">
                        Transactions PPL action needed
                      </b-form-checkbox>
                    </b-col>
                  <b-col cols="4" v-if="_.includes(['01','02'],request.requestStatusValue.code) && request.leaveDecision === 'Approved' ">
                      <b-form-checkbox
                          v-model="payrollPPL"
                          :v="$v.payrollPPL"
                          name="probation">
                        Payroll PPL action needed
                      </b-form-checkbox>
                      <b-form-checkbox
                          v-model="payrollFMLA"
                          :v="$v.payrollFMLA"
                          name="probation">
                        Payroll FMLA action needed
                      </b-form-checkbox>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-table hover small show-empty
                                 responsive="true"
                                 :fields="leaveCommentFields"
                                 :items="request.leaveComments"
                                 :busy="false">
                            <template v-slot:no-data>
                                No Leave or Request Returned Comments Found.
                            </template>
                            <div slot="table-busy" class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                            <template slot="empty" slot-scope="scope">
                                No Leave or Request Returned Comments Found.
                            </template>
                        </b-table>
                    </b-col>
                </b-row>
                <b-row v-if="hasLeaveRole && isEditing">
                  <b-col cols="5">
                      <BaseSelector v-model="request.standardLeaveComment"
                                          :v="$v.request.standardLeaveComment"
                                          label="Standard Leave Comments"
                                          :options="standardComments"
                                          textField="comment"
                                          valueField="id"
                      />
                  </b-col>
                  <b-col cols="5">
                    <BaseParagraphInput v-model="request.leaveComment"
                                        :v="$v.request.leaveComment"
                                        slug="leaveComment"
                                        label="Leave Comments"/>
                  </b-col>
                  <b-col cols="2">
                      <b-button type="button" variant="primary" @click="saveComment" class="mt-4">Create Comment</b-button>
                  </b-col>
                </b-row>
            </div>
        </div>

        <div class="card" header-bg-variant="primary" header-text-variant="white">
            <div class="card-header">Organizational Information</div>
            <div class="card-body">
                <b-row>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Division" :value="request.division" v-if="!isEditing"/>
                      <BaseDivisionSelector v-model="request.division" v-if="isEditing"
                                            :v="$v.request.division"
                                            :required="$v.request.division.$params.required ? true : false"
                                            slug="division"
                                            label="Division"/>
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Department ID" :value="request.departmentId" v-if="!isEditing"/>
                        <BaseDepartmentSelector v-model="request.departmentId" v-if="isEditing"
                                        :v="$v.request.departmentId"
                                        slug="department"
                                        label="Department ID"/>
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Unit Name" :value="request.unitName" v-if="!isEditing"/>
                      <BaseTextInput v-model="request.unitName" v-if="isEditing"
                                     :v="$v.request.unitName"
                                     :required="$v.request.unitName.$params.required ? true : false"
                                     slug="unit"
                                     label="Unit Name"/>
                    </b-col>
                </b-row>
                <b-row v-if="!_.includes(['10', '13', '36'], this.request.requestTypeValue.code)">
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="First Approver (Division Director)"
                                        :value="getApprover('DD')"/>
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Second Approver (Assistant Commissioner)" :value="getApprover('AC')" v-if="!isDirectorEditing"/>
                        <BaseEmployeeSelector v-model="approver" v-if="isDirectorEditing"
                                              :label="'Second Approver (Assistant Commissioner)'"
                                              :v="$v.approver"
                                              :showPcn="true"
                                              :messages="approverMessages"
                                              tip="Default 2nd approver is listed above. You can change it for this request, if necessary.
                                              2nd approver cannot be the same as 1st Approver if they are also the Hiring Manager/Supervisor or Request Initiator."/>
                    </b-col>
                </b-row>
                <b-row v-if="!_.includes(['10', '13', '36'], this.request.requestTypeValue.code)">
                    <b-col cols="12" lg="4">
                        <BaseTextOutput label="Staffing Specialist"
                                        :value="request.staffingSpecialist"/>
                    </b-col>
                    <b-row style="margin-bottom:18px;" v-if="isDirectorApproval">
                        <b-col>
                            <b-button type="button" variant="primary" v-if="!isDirectorEditing" @click="toggleDirectorEdit(false)">Edit Second Approver</b-button>
                            <b-button type="button" variant="primary" v-if="isDirectorEditing" @click="saveDirectorEdits">Update Second Approver</b-button>
                            <b-button type="button" variant="outline-primary" v-if="isDirectorEditing" @click="toggleDirectorEdit(true)">Cancel Editing</b-button>
                        </b-col>
                    </b-row>
                </b-row>
            </div>
        </div>

        <div class="card" header-bg-variant="primary" header-text-variant="white"
            v-if="_.includes(['01', '02', '03','04', '05', '06', '07', '08', '10','12'], request.requestTypeValue.code)">
            <div class="card-header">Supervisor</div>
            <div class="card-body">

            <b-row v-if="!isEditing">
                <b-col cols="12" lg="3">
                    <BaseTextOutput label="Name" :value="request.supervisor.name"/>
                </b-col>
                <b-col cols="12" lg="3">
                    <BaseTextOutput label="Email" :value="request.supervisor.email"/>
                </b-col>
                <b-col cols="12" lg="3">
                    <BaseTextOutput label="Phone #" :value="request.supervisor.phoneNbr"/>
                </b-col>
                <b-col cols="12" lg="3">
                    <BaseTextOutput label="PCN" :value="request.supervisor.pcn"/>
                </b-col>
            </b-row>
            <b-row v-if="isEditing">
                <b-col cols="12">
                    <BaseEmployeeSelector v-model="request.supervisor" v-if="isEditing"
                                        label="Supervisor"
                                        :v="$v.request.supervisor.userId"
                                        :key="keys.supervisor"
                                        v-on:input='forceSupervisorRerender'
                                        slug="supervisor"
                                        :showPcn="true"
                                        tip=""/>
                </b-col>
            </b-row>
        </div>
    </div>

    <div class="card" header-bg-variant="primary" header-text-variant="white"
             v-if="!_.includes(['10'], request.requestTypeValue.code)">
        <div class="card-header">Supervisory Position</div>
        <div class="card-body">
            <b-row v-if="!isEditing">
                <b-col cols="12" lg="12">
                    <BaseTextOutput label="What percentage of time will be spend on supervisory activites?" :value="request.superWorkAllocation"/>
                </b-col>
                <b-col cols="12" lg="6">
                    <BaseTextOutput label="Will the supervisor work the same hours as their immediate supervisor?" :value="request.superSameHours"/>
                </b-col>
                <b-col cols="12" lg="6">
                    <BaseTextOutput label="If no, please explain" :value="request.superSameHoursText"/>
                </b-col>
                <b-col cols="12" lg="6">
                    <BaseTextOutput label="Will the new supervisor be geographically separated from immediate supervisor''s location?"
                     :value="request.superDifferentLocation"/>
                </b-col>
                <b-col cols="12" lg="6">
                    <BaseTextOutput label="If yes, please explain" :value="request.superDifferentLocationText"/>
                </b-col>
            </b-row>

            <b-row v-if="!isEditing">
                <b-col>
                    <b-table-simple id="directReports" hover small caption-top responsive>
                        <b-thead>
                            <b-tr>
                                <b-th>Classification</b-th>
                                <b-th>Employment Condition</b-th>
                                <b-th>Count</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="(item, index) in request.reports" :key="index">
                                <b-td>{{item.classification}}</b-td>
                                <b-td>{{item.empCondition}}</b-td>
                                <b-td>{{item.count}}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-col>
            </b-row>

            <b-row v-if="isEditing">
                <b-col cols="12" lg="6">
                    <BaseMoneyInput v-model="request.superWorkAllocation"
                        :v="$v.request.superWorkAllocation"
                        slug="superWorkAllocation"
                        label="What percentage of time will be spend on supervisory activites?"/>
                </b-col>
            </b-row>
            <b-row v-if="isEditing">
                <b-col cols="12" lg="6">
                     <BaseSelector v-model="request.superSameHours" 
                            :v="$v.request.superSameHours"
                            label="Will the supervisor work the same hours as their immediate supervisor?"
                            slug="superSameHours"
                            :options = yesNoOptions />
                </b-col>
                <b-col cols="12" lg="6">
                    <BaseParagraphInput v-model="request.superSameHoursText"
                        v-if="request.superSameHours && request.superSameHours ==='N'"
                        :v="$v.request.superSameHoursText"
                        label="If no, please explain"
                        slug="superSameHoursText"
                        tip=""/>
                </b-col>
            </b-row>
            <b-row v-if="isEditing">
                <b-col cols="12" lg="6">
                     <BaseSelector v-model="request.superDifferentLocation" 
                            :v="$v.request.superDifferentLocation"
                            label="Will the new supervisor be geographically separated from immediate supervisor''s location?"
                            slug="superDifferentLocation"
                            :options = yesNoOptions />
                </b-col>
                <b-col cols="12" lg="6">
                    <BaseParagraphInput v-model="request.superDifferentLocationText"
                        v-if="request.superDifferentLocation && request.superDifferentLocation ==='Y'"
                        :v="$v.request.superDifferentLocationText"
                        label="If yes, please explain"
                        slug="superDifferentLocationText"
                        tip=""/>
                </b-col>
            </b-row>

             <b-row v-if="isEditing">
                <b-col class="mt-3">
                    <b-table-simple id="directReports" hover small caption-top responsive >
                        <b-thead>
                            <b-tr>
                                <b-th style="width: 30rem" colspan="3">Direct Reports</b-th>
                                <b-th style="width: 2rem">Remove</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="(item, index) in request.reports" :key="index">
                                <b-td>                                
                                    <BaseClassificationSelector v-model="item.classification"
                                        :v="$v.request.reports.$each[index].classification"
                                        label="Employee Classification"
                                        sr="Search for Employee Classification"/>
                                </b-td>
                                
                                <b-td>
                                    <BaseSelector v-model="item.empCondition" 
                                        :v="$v.request.reports.$each[index].empCondition"
                                        label="Employment Condition"
                                        :options = positionScheduleOptions />
                                </b-td>
                                <b-td>
                                    <BaseMoneyInput v-model="item.count"
                                        :v="$v.request.reports.$each[index].count"
                                        label="Employee Count"/>
                                </b-td>                            
                                <b-td>
                                    <b-button size="sm" variant="link" @click="removeReportsRow(index)"
                                        aria-label="remove direct report" title="remove direct report">
                                        <b-icon icon="x-circle-fill" aria-hidden="true"></b-icon>
                                    </b-button>
                                </b-td> 
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                    <b-button variant="outline-primary" size="sm"
                        @click="addReportsRow()">
                        Add additional direct report
                    </b-button>
                </b-col>
            </b-row>
        </div>
    </div>

    <div class="card" header-bg-variant="primary" header-text-variant="white"
        v-if="_.includes(['09'], request.requestTypeValue.code)">
        <div class="card-header">Position Requirements</div>
        <div class="card-body">

            <b-row>
                <b-col>
                    <BaseTextOutput label="Software Experience Needed" :value="request.softwareExpNeeded"
                        v-if="!isEditing && _.includes(['09'], request.requestTypeValue.code)"/>
                    <BaseParagraphInput v-model="request.softwareExpNeeded"
                        v-if="isEditing && _.includes(['09'], request.requestTypeValue.code)"
                        :v="$v.request.softwareExpNeeded"
                        label="Software Experience Needed"
                        slug="softwareExpNeeded"
                        tip=""/>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <BaseTextOutput label="Required Licenses/Certifications" :value="request.licCredsRequired"
                        v-if="!isEditing && _.includes(['09'], request.requestTypeValue.code) && !isEditing"/>
                    <BaseParagraphInput v-model="request.licCredsRequired"
                        v-if="isEditing && _.includes(['09'], request.requestTypeValue.code) && isEditing"
                        :v="$v.request.licCredsRequired" 
                        label="Required Licenses/Certifications"
                        slug="licCredsRequired"
                        tip=""/>
                </b-col>
            </b-row>       
            <b-row>
                <b-col>
                    <BaseTextOutput label="Specific Staff Requested" :value="request.specificStaffRequested"
                        v-if="_.includes(['09'], request.requestTypeValue.code)"/>
                  <BaseParagraphInput v-model="request.specificStaffRequested"
                                      v-if="_.includes(['09'], request.requestTypeValue.code)"
                                      :v="$v.request.specificStaffRequested"
                                      label="Specific Staff Requested"
                                      slug="specificStaffRequested"
                                      tip=""/>
                </b-col>
            </b-row>    
        </div>
    </div>


    <div class="card" header-bg-variant="primary" header-text-variant="white"
             v-if="!_.includes(['10'], request.requestTypeValue.code)">
        <div class="card-header">Finance Information</div>
        <div class="card-body">
            <b-row>
                <b-col>
                    <b-table-simple id="fundingStrs" hover small caption-top responsive>
                        <b-thead>
                            <b-tr>
                                <b-th>Percent</b-th>
                                <b-th>Fund</b-th>
                                <b-th>Fin Dept ID</b-th>
                                <b-th>Approp ID</b-th>
                                <b-th>SW Cost</b-th>
                                <b-th>Sub Acct</b-th>
                                <b-th>Agcy Cost 1</b-th>
                                <b-th>Agcy Cost 2</b-th>
                                <b-th>Project</b-th>
                                <b-th>Activity</b-th>
                                <b-th>Source</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody v-if="!isEditing">
                            <b-tr v-for="(item, index) in request.funding" :key="index">
                                <b-td>{{item.fundingPercent}}</b-td>
                                <b-td>{{item.fundId}}</b-td>
                                <b-td>{{item.divisionId}}</b-td>
                                <b-td>{{item.appropriationId}}</b-td>
                                <b-td>{{item.swCost}}</b-td>
                                <b-td>{{item.subAccount}}</b-td>
                                <b-td>{{item.agcyCost1}}</b-td>
                                <b-td>{{item.agcyCost2}}</b-td>
                                <b-td>{{item.project}}</b-td>
                                <b-td>{{item.activity}}</b-td>
                                <b-td>{{item.sourceType}}</b-td>
                            </b-tr>
                        </b-tbody>
                      <b-tbody v-if="isEditing">
                        <b-tr v-for="(item, index) in request.funding" :key="index">
                          <b-td><b-form-input v-model="item.fundingPercent" aria-label="Percent"
                                              :class="{'is-invalid':$v.request.funding.$each[index].fundingPercent.$invalid,
                                        'is-valid':!$v.request.funding.$each[index].fundingPercent.$invalid}" /></b-td>
                          <b-td><b-form-input v-model="item.fundId" aria-label="Fund"
                                              :class="{'is-invalid':$v.request.funding.$each[index].fundId.$invalid,
                                        'is-valid':!$v.request.funding.$each[index].fundId.$invalid}"/></b-td>
                          <b-td><b-form-input v-model="item.divisionId" aria-label="Fin Dept ID"
                                              :class="{'is-invalid':$v.request.funding.$each[index].divisionId.$invalid,
                                        'is-valid':!$v.request.funding.$each[index].divisionId.$invalid}"/></b-td>
                          <b-td><b-form-input v-model="item.appropriationId" aria-label="Approp ID"
                                              :class="{'is-invalid':$v.request.funding.$each[index].appropriationId.$invalid,
                                        'is-valid':!$v.request.funding.$each[index].appropriationId.$invalid}"/></b-td>
                          <b-td><b-form-input v-model="item.swCost" aria-label="SW Cost"/></b-td>
                          <b-td><b-form-input v-model="item.subAccount" aria-label="Sub Acct"/></b-td>
                          <b-td><b-form-input v-model="item.agcyCost1" aria-label="Agcy Cost 1"
                                              :class="{'is-invalid':$v.request.funding.$each[index].agcyCost1.$invalid,
                                        'is-valid':!$v.request.funding.$each[index].agcyCost1.$invalid}"/></b-td>
                          <b-td><b-form-input v-model="item.agcyCost2" aria-label="Agcy Cost 2"/></b-td>
                          <b-td><b-form-input v-model="item.project" aria-label="Project" maxlength="15" @keyup="maxLengthAlert"
                                              :class="{'is-invalid':$v.request.funding.$each[index].project.$invalid,
                                        'is-valid':!$v.request.funding.$each[index].project.$invalid}"/></b-td>
                          <b-td><b-form-input v-model="item.activity" aria-label="Activity"
                                              :class="{'is-invalid':$v.request.funding.$each[index].activity.$invalid,
                                        'is-valid':!$v.request.funding.$each[index].activity.$invalid}" /></b-td>
                          <b-td><b-form-select v-model="item.sourceType" aria-label="Source Type"
                                               :options="sourceTypeOptions"
                                               :class="{'is-invalid':$v.request.funding.$each[index].sourceType.$invalid,
                                        'is-valid':!$v.request.funding.$each[index].sourceType.$invalid}"/></b-td>
                          <b-td>
                          </b-td>
                        </b-tr>
                        <b-tr>
                          <b-td></b-td><b-td></b-td><b-td></b-td><b-td></b-td><b-td></b-td><b-td></b-td><b-td></b-td><b-td></b-td>
                          <b-td><span v-if="displayWarning" :class="{'text-danger': displayWarning}">Maximum of {{ projectMaxLength }} characters reached.</span></b-td>
                          <b-td></b-td><b-td></b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                </b-col>
            </b-row>
        </div>
    </div>

    <div class="card" header-bg-variant="primary" header-text-variant="white">
        <div class="card-header">Request Approvals</div>
        <div class="card-body">
        <b-row v-for="approver in request.approvals" :key="approver.approvalStatusDatetime">
            <b-col>
                <BaseTextOutput label="Role" :value="approver.approvalType"/>
            </b-col>
            <b-col>
                <BaseTextOutput label="Outcome" :value="approver.approvalStatus"/>
            </b-col>
            <b-col>
                <BaseTextOutput label="Date" :value="approver.approvalStatusDatetime"/>
            </b-col>
            <b-col>
                <BaseTextOutput label="Approver" :value="approver.approver.name"/>
            </b-col>
        </b-row>
        <!--
        <b-row>
            <b-col>
                <BaseEmployeeSelector v-model="divDirector.approver"
                    label="Division Director"
                    :v="$v.divDirector.approver"
                    tip=""/>
            </b-col>
            <b-col>
                <BaseEmployeeSelector v-model="asstCommissioner.approver"
                    label="Assistant Commissioner"
                    :v="$v.asstCommissioner.approver"
                    tip=""/>
            </b-col>
        </b-row>
        -->
        </div>
        </div>

    <LifecycleHistory :requestId="request.id"/>

    </b-form>


    <b-modal id="pcnUpdateModal" title="Update PCN Request" size="lg" hide-footer>
        <BaseParagraphInput v-model="request.pcnUpdateComment"
                :v="$v.request.pcnUpdateComment" 
                label="Please describe the PCN Update Request"
                slug="pcnUpdateComments"
                tip=""/>

        <b-button @click="close" style="margin-right:15px;">Cancel</b-button>
        <b-button type="button" variant="primary" @click="savePcnRequest">Save</b-button>
    </b-modal>

    </div>
</div>
</template>

<script>
import axios from "axios"
import _ from "lodash"
import {
  required,
  email,
  minLength,
  decimal,
  maxLength,
  minValue,
  maxValue,
  numeric,
  requiredUnless,
  requiredIf,
  helpers,
  integer
} from 'vuelidate/lib/validators'
import AssignSpecialist from '@/components/AssignSpecialist'
import RequesterReviewLifecycle from '@/components/lifecycles/RequesterReviewLifecycle'
import RequesterReviewPostingLifecycle from '@/components/lifecycles/RequesterReviewPostingLifecycle'
import CFOReview from '@/components/CFOReview'
import AuditLifecycle from '@/components/lifecycles/AuditLifecycle'
import AssignedLifecycle from '@/components/lifecycles/AssignedLifecycle'
import DraftPostingLifecycle from '@/components/lifecycles/DraftPostingLifecycle'
import PostedLifecycle from '@/components/lifecycles/PostedLifecycle'
import RePostedLifecycle from '@/components/lifecycles/RePostedLifecycle'
import RDCLifecycle from '@/components/lifecycles/RDCLifecycle'
import RDCCandidate from '@/components/lifecycles/RDCCandidate'
import RDCOnboard from '@/components/lifecycles/RDCOnboard'
import ScreenApplicantsLifecycle from '@/components/lifecycles/ScreenApplicantsLifecycle'
import ManagerInterviewLifecycle from '@/components/lifecycles/ManagerInterviewLifecycle'
import PreOfferLifecycle from '@/components/lifecycles/PreOfferLifecycle'
import SalaryLifecycle from '@/components/lifecycles/SalaryLifecycle'
import OfferLifecycle from '@/components/lifecycles/OfferLifecycle'
import MakeOfferLifecycle from '@/components/lifecycles/MakeOfferLifecycle'
import BackgroundLifecycle from '@/components/lifecycles/BackgroundLifecycle'
import CompleteLifecycle from '@/components/lifecycles/CompleteLifecycle'
import { commonOptions } from '@/mixins/commonOptions.js'
import { tableFields } from '@/mixins/tableFields.js'
import datePicker from 'vue-bootstrap-datetimepicker'
import LifecycleHistory from '@/components/LifecycleHistory'
import FileAttachment from '@/components/FileAttachment'
import AssignPCN from '@/components/lifecycles/AssignPCN'
import UpdatePCN from '@/components/lifecycles/UpdatePCN'
import PayrollReviewLifecycle from "@/components/lifecycles/payroll-lifecycles/PayrollReviewLifecycle.vue";
import BaseSelector from "@/components/BaseSelector";
import BaseParagraphInput from "@/components/BaseParagraphInput";
import BaseTextOutput from "@/components/BaseTextOutput";
import BaseTextInput from "@/components/BaseTextInput";
import CloseOutTransactionLifecycle from "@/components/lifecycles/CloseOutTransactionLifecycle";
import PayrollFMLA from "@/components/lifecycles/payroll-lifecycles/PayrollFMLA";
import PayrollPPL from "@/components/lifecycles/payroll-lifecycles/PayrollPPL";
import TransactionPPLLifecycle from "@/components/lifecycles/TransactionPPLLifecycle";
import minDate from "@/validators/minDate";
import pageTitle from '@/mixins/pageTitle'
import BaseSema4Attributes from "@/components/BaseSema4Attributes.vue";
import {roleService} from "@/mixins/roleService";

const agcyValidator = (value) => !helpers.req(value) || (value >= 40000 && value <= 40002)
const terms = ['TBD', 'tbd']
const tbdValidator = (value) => !terms.some(el => value && value.indexOf(el) > -1)

export default {
    title () {
      return `View/Edit HRM Request`
    },
    data() {
        return {
            keys: {
                location: 0,
                supervisor: 0,
                requestType: 0,
                leaveType: 0,
                denial: 0,
            },
            previousRequest: {},
            request: {
                approvals: [],
            },
            approver: {},
            specialists: [],
            leaveTypeSubOptions: [],
            selectedSkills: [],
            reofferReasons: [],
            reofferReasonString: "",
            hasOtherRequiredSkill: false,
            initialPageLoading: true,
            isAssignedLifecycle: false,
            isRequesterReviewLifecycle: false,
            isReviewPosting: false,
            isUnassigned: false,
            isAssigned: false,
            allowAttachments: false,
            isPrimaryAssigned: false,
            isAuditLifecycle: false,
            isDraftPosting: false,
            isPosted: false,
            isReposted: false,
            isScreening: false,
            isManagerInterviewing: false,
            isSalaryReview: false,
            isPreOffer: false,
            isMakeOffer: false,
            isBackgroundCheck: false,
            isComplete: false,
            isRDCSubmission: false,
            isRDCCandidate: false,
            isRDCOnboard: false,
            isOnHold: false,
            isEditing: false,
            isEditingAttachments: false,
            isDirectorApproval: false,
            isDirectorEditing: false,
            isProcessing: false,
            transitionStatus: null,
            isReadyForCFOReview: false,
            isAssignPcn: false,
            isUpdatePcn: false,
            isCloseOut: false,
            isTransactionPPL: false,
            attachmentRequirements: [],
            attachmentTypes: [],
            approvalStatusOptions: [
                { value: 'P', text: 'Pending' },
                { value: 'A', text: 'Approved' },    
                { value: 'R', text: 'Rejected' },    
            ],
            transitionLifeCycleOptions: [
                { value: '06', text: 'Start Audit' },
                { value: '07', text: 'Start Draft' },
                { value: '08', text: 'Posted'},
                { value: '09', text: 'Screen Applicants'},
            ],
            attachmentFields:  [
                {key: 'filename', sortable: true, label: 'File Name'},
                {key: 'type', sortable: true, label: 'File Type', formatter: 'getFileType'},
                {key: 'actions', label: 'Actions'}
            ],
            priorityOptions: [
              { value: '1', text: 'P1' },
              { value: '2', text: 'P2' },
              { value: '3', text: 'P3' },
              { value: '4', text: 'P4' },
              { value: '5', text: 'P5' },
               { value: '6', text: 'P6' },
                { value: '7', text: 'P7' },
                { value: '8', text: 'P8' },
                { value: '9', text: 'P9' },
                { value: '10', text: 'P10' },
                { value: '11', text: 'P11' },
                { value: '12', text: 'P12' },
                { value: '13', text: 'P13' },
                { value: '14', text: 'P14' },
                { value: '15', text: 'P15' },
                { value: '16', text: 'P16' },
                { value: '17', text: 'P17' },
                { value: '18', text: 'P18' },
                { value: '19', text: 'P19' },
                { value: '20', text: 'P20' },
                { value: '999', text: ' ' },
            ],
            options: {
                format: 'YYYY-MM-DD',
                useCurrent: false,
            },
            needsMyICSApproval: {},
            defaultRequestAttributes: {
                positionClassificationValue: {
                    code: '',
                    description: ''
                },
                appointmentValue: {
                    code: '',
                    description: ''
                },
                workScheduleValue: {
                    code: '',
                    description: ''
                },
                positionScheduleValue: {
                    code: '',
                    description: ''
                },
                workTravelValue: {
                    code: '',
                    description: ''
                },
                attachments: [],
                isLeaveRequestClosed: false
            },
            auditApprovedDate: null,
            salaryApprovedDate: null,
            salaryApprovedBy: null,
            payrollAction: null,

            payrollPPL: false,
            payrollFMLA: false,
            transactionPPL: false,
            phases: [],
            standardComments: [],
            approverMessages: {approverValid: 'The 2nd approver cannot be the same as 1st Approver if they are also the Hiring Manager/Supervisor or Request Initiator'},

            projectMaxLength: 15,
            displayWarning: false,

            pcnSema4Attributes: {
                asOfDate: '',
                posCd: '',
                deptId: '',
                deptLd: '',
                locLd: '',
                jobcodeLd: '',
                moptionCd: '',
                wjobOptionLd: '',
                reportsTo: '',
                regTempLd: '',
                clsIndLd: '',
                posFullPtCd: '',
                stdHours: '',
                posFtePct: '',
                flsaStatLd: '',
                unionCd: '',
            },
            fundingData: {
                isValid: '',
                positionNbr: '',
                distPct: '',
                fundCode: '',
                deptidCf: '',
                chartfield3: '',
                projectdescr: '',
                activityId: '',
                resourceType: '',
                seqNo: ''
            },
            isShowingPcnAttributes: false,
        }
    },
mixins: [
       commonOptions,
       pageTitle,
       tableFields,
       roleService,
    ],    
    
    components: {
      BaseSema4Attributes,
      TransactionPPLLifecycle,
      PayrollPPL,
      PayrollFMLA,
      CloseOutTransactionLifecycle,
      BaseParagraphInput,
      BaseSelector,
      BaseTextOutput,
      BaseTextInput,
      PayrollReviewLifecycle,
      AssignSpecialist,
      AssignedLifecycle,
      AuditLifecycle,
      DraftPostingLifecycle,
      PostedLifecycle,
      RePostedLifecycle,
      ScreenApplicantsLifecycle,
      ManagerInterviewLifecycle,
      PreOfferLifecycle,
      SalaryLifecycle,
      OfferLifecycle,
      BackgroundLifecycle,
      CompleteLifecycle,
      datePicker,
      LifecycleHistory,
      CFOReview,
      RDCLifecycle,
      RDCCandidate,
      RDCOnboard,
      FileAttachment,
      AssignPCN,
      UpdatePCN,
      RequesterReviewLifecycle,
      RequesterReviewPostingLifecycle,
      MakeOfferLifecycle
    },

  validations() {
    return {
      transitionStatus: {},

      needsMyApproval: {
        approvalStatus: {required},
        comments: {required: false, maxLength: maxLength(1000)},
        approverValid: this.validateDefaultApprover
      },

      needsMyICSApproval: {
        approvalStatus: {required},
        comments: {required: false, maxLength: maxLength(1000)}
      },

      request: {
        positionNumber: {
          required: requiredIf(function () {
            return _.includes(['02', '03', '04', '05', '06', '07', '12'], this.request.requestTypeValue.code)
          }),
          maxLength: maxLength(8)
        },

        proposedClassification: {
          required: requiredIf(function () {
            return _.includes(['01', '02', '03', '04', '05', '06', '07', '08', '12'], this.request.requestTypeValue.code)
          })
        },

        previousIncumbent: {
          required: false,
          maxLength: maxLength(50)
        },

        classOption: {
          required: false,
          maxLength: maxLength(50)
        },

        workingTitle: {
          required: false,
          maxLength: maxLength(50)
        },

        positionLocation: {
          required: requiredIf(function () {
            return _.includes(['01', '02', '08', '09'], this.request.requestTypeValue.code)
          }),
          maxLength: maxLength(50),
        },

        hoursPerWeek: {
          required: requiredIf(function () {
            return _.includes(['01', '02', '08', '09'], this.request.requestTypeValue.code)
          }),
          numeric
        },

        workingHours: {
          required: requiredIf(function () {
            return _.includes(['01', '02', '08'], this.request.requestTypeValue.code)
          }),
          maxLength: maxLength(50)
        },

        division: {
          required: requiredIf(function () {
            return _.includes(['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '12'], this.request.requestTypeValue.code)
          }),
        },

        departmentId: {
          required: requiredIf(function () {
            return _.includes(['01', '02', '03', '04', '05', '06', '07', '08', '12'], this.request.requestTypeValue.code)
          }),
        },

        unitName: {
          required: false
        },


        supervisor: {
          userId: {
            required: requiredIf(function () {
              return _.includes(['01', '02', '03', '04', '05', '06', '07', '08', '10', '12'], this.request.requestTypeValue.code)
            }),
          }
        },

        employee: {
          userId: {
            required: requiredIf(function () {
              return _.includes(['10'], this.request.requestTypeValue.code)
            }),
          }
        },

        leaveType: {
          required: requiredIf(function () {
            return _.includes(['10'], this.request.requestTypeValue.code)
          })
        },

        workStatus: {
          required: requiredIf(function () {
            return _.includes(['10'], this.request.requestTypeValue.code)
          })
        },


        leaveDecision: {
          required: requiredIf(function () {
            return _.includes(['10'], this.request.requestTypeValue.code)
          })
        },

        denialReason: {
          required: requiredIf(function () {
            return this.request.leaveDecision === 'Denied'
          })
        },

        comments: {
          required: false,
          maxLength: maxLength(4000)
        },

        requestTypeValue: {
          code: {
            required: true
          }
        },

        positionClassificationValue: {
          code: {required: false}
        },

        positionScheduleValue: {
          code: {
            required: requiredIf(function () {
              return _.includes(['01', '02', '08', '09', '10'], this.request.requestTypeValue.code)
            })
          }
        },

        appointmentValue: {
          code: {
            required: requiredIf(function () {
              return _.includes(['01', '02', '03', '04', '05', '06', '08', '12'], this.request.requestTypeValue.code)
            })
          }
        },

        workScheduleValue: {
          code: {
            required: requiredIf(function () {
              return _.includes(['09'], this.request.requestTypeValue.code)
            })
          }
        },

        workTravelValue: {
          code: {
            required: requiredIf(function () {
              return _.includes(['01', '02', '08', '09'], this.request.requestTypeValue.code)
            })
          }
        },

        anticipatedStartDate: {
          required: requiredIf(function () {
            return _.includes(['01', '02', '08', '09', '10'], this.request.requestTypeValue.code)
          })
        },

        endDate: {
          required: requiredIf(function () {
            return _.includes(['07', '09', '10'], this.request.requestTypeValue.code)
          })
        },
        typeOfCovidLeave: {
          required: false,
          maxLength: maxLength(20)
        },
        workRestrictions: {
          required: false,
          maxLength: maxLength(15)
        },
        addlAuthNeeded: {
          required: false,
          maxLength: maxLength(15)
        },

        covidLeaveHrsUsed: {
          numeric,
          required: false
        },
        efmlaHrs: {
          required: false
        },
        leaveHours: {
          numeric,
          required: false
        },
        ptLeaveNeeds: {
          required: false,
          maxLength: maxLength(500)
        },

        selectedCandidateEmail: {maxLength: maxLength(75)},
        selectedCandidateName: {maxLength: maxLength(75)},
        selectedCandidateEmployeeId: {maxLength: maxLength(75)},
        selectedCandidateAddress: {maxLength: maxLength(75)},
        selectedCandidatePhone: {maxLength: maxLength(75)},
        flsaStatusValue: {},
        bargainingUnit: {},

        funding: {
          required: requiredUnless(function () {
            return _.includes(['10', '03', '06', '05'], this.request.requestTypeValue.code)
          }),
          minLength: minLength(1),
          $each: {
            fundingPercent: {
              required,
              numeric
            },
            fundId: {
              required,
              tbdValidator
            },
            divisionId: {
              required,
              tbdValidator
            },
            sourceType: {
                required: requiredIf(function(item) {
                    return item.project || item.activity
                }),
            },
            appropriationId: {
              required,
              tbdValidator
            },
            agcyCost1: {
              required: requiredIf(function (item) {
                if (item.divisionId) {
                  return item.divisionId.endsWith('3201')
                }
                return false
              }),
              agcyValidator,
              tbdValidator
            },
            project: {
                required: requiredIf(function(item) {
                    return ((item.fundId === '3000' || item.fundId === '3001') ||
                            (item.activity || item.sourceType))
                }),
                tbdValidator
            },
            activity: {
                required: requiredIf(function(item) {
                    return item.project || item.sourceType
                }),
                maxLength: maxLength(15),
                tbdValidator
            }
          }
        },

        superWorkAllocation: {
              decimal,
              minValue: minValue(0),
              maxValue: maxValue(100),
              required: requiredIf(function() {
                  return this.request.superPosition && this.request.superPosition === 'Y'
              })
          },

          superSameHours: {
              required: requiredIf(function() {
                  return this.request.superPosition && this.request.superPosition === 'Y'
              })
          },

          superSameHoursText: {
              required: requiredIf(function() {
                  return this.request.superSameHours && this.request.superSameHours === 'N'
              }),
              maxLength: maxLength(4000)
          },

          superDifferentLocation: {
              required: requiredIf(function() {
                  return this.request.superPosition && this.request.superPosition === 'Y'
              })
          },

          superDifferentLocationText: {
              required: requiredIf(function() {
                  return this.request.superDifferentLocation && this.request.superDifferentLocation === 'Y'
              }),
              maxLength: maxLength(4000)
          },

          reports: {
              required: requiredIf(function() {
                  return this.request.superDifferentLocation && this.request.superDifferentLocation === 'Y'
              }),
              minLength: minLength(1),
              $each: {
                  classification: {
                      required,
                  },
                  empCondition: {
                      required,
                  },
                  count: {
                      required,
                      numeric
                  }                        
              }
          },
          
        coopLevel: {
          required: requiredIf(function () {
            return _.includes(['09'], this.request.requestTypeValue.code)
          })
        },

        dlRequired: {
          required: requiredIf(function () {
            return _.includes(['09'], this.request.requestTypeValue.code)
          })
        },

        teleworkAvailable: {
          required: false,
          maxLength: maxLength(1000)
        },

        softwareExpNeeded: {
          required: false,
          maxLength: maxLength(1000)
        },

        licCredsRequired: {
          required: requiredIf(function () {
            return _.includes(['09'], this.request.requestTypeValue.code)
          }),
          maxLength: maxLength(1000)
        },

        specificStaffRequested: {
          required: false,
          maxLength: maxLength(4000)
        },
        otherSkillSet: {
          required: false,
          maxLength: maxLength(100)
        },
        isLeaveRequestComplete: {required: false},
        isLeaveRequestClosed: {required: false},
        effectiveStartDate: {required: false},
        pcnUpdateComment: {required: false, maxLength: maxLength(1000)},
        step: {maxLength: maxLength(3)},
        rate: {decimal},
        probationaryPeriodLength: {maxLength: maxLength(20)},

        leaveRequestReceived: {required: false},
        certificationDeadline: {required: false},
        medCertReceived: {required: false},
        fmlaReason: {required: false},
        nbrCases: {required: false, integer},
        parenthoodLeaveConcurrent: {required: false},
        onProbation: {required: false},

        priority: {required: false},
        jobId: {maxLength: maxLength(10)},
        dd14ReceivedDate: {required: false},

        effectiveEndDate: {required: false, minDate: minDate(this.request.effectiveStartDate)},
        leaveComment: {required: false, maxLength: maxLength(4000)},
        standardLeaveComment: {required: false},
        delegate: {
          userId: { required: false }
        },
        attachmentTypes: []
      },

      approver: {
          required: requiredIf(function() {
              return !_.includes(['10', '13', '36'], this.request.requestTypeValue.code)
          }),
          approverValid: this.validateNewApprover
      },
    }
  },

     computed: {
        _: function() {
            return _
        },

       isOffer: function() {
         return (this.request.requestStatusValue.code === '12' && (this.isAssigned || this.isFfm()))
             || (this.request.financeRequiresReview === true && this.isFfm())
       },

       showCancelButton: function() {
           return _.some(['01', '04', '06', '07', '08', '09', '10', '11', '12', '13', '14', '16'],
                        _.matches(this.request.requestStatusValue.code))
       },

       hasCFORole() {
           return this.isCfo()
       },

       hasLeaveRole() {
           return this.isLeave()
       },

       hasTransactionRole() {
           return this.isHRTransactions()
       },
       hasPayrollRole(){
         return this.isPayroll() || this.isAdmin()
       },
       hasPayrollStatus() {
          return _.includes(['REV'], this.payrollAction) || this.findPayrollActionStatus(38)
       },

       isHiringManager() {
          let aSubmitter = this.request.submitter.userId && this.request.submitter.userId.toLowerCase() === this.$keycloak.userName.toLowerCase()
          let aSupervisor = this.request.supervisor.userId && this.request.supervisor.userId.toLowerCase() === this.$keycloak.userName.toLowerCase()
          return _.some(['33'], _.matches(this.request.requestStatusValue.code)) && (aSubmitter || aSupervisor)
       },

       isEditable() {
           let result = true

           if (this.request.requestTypeValue.code === '09' && this.request.requestStatusValue.code === '01') {
               result = false
           }
           return result
       },

     },

    watch: {
        request: {
            deep: true,
            handler() {
                this.isUnassigned = this.request.requestStatusValue.code === '02' &&
                    !this.request.assigned.userId && 
                    !this.request.requestTypeValue.code === '09'

                this.isReadyForCFOReview = this.request.requestStatusValue.code === '02' && 
                    this.request.requestTypeValue.code === '09' &&
                    this.hasCFORole

                this.setAssigned()

                this.isOnHold = this.request.requestStatusValue.code === '05' && this.isAssigned
                this.isAssignedLifecycle = this.request.requestStatusValue.code === '04' && this.isAssigned
                this.isRequesterReviewLifecycle = this.request.requestStatusValue.code === '33'
                this.isReviewPosting = this.request.requestStatusValue.code === '34'
                this.isAuditLifecycle = this.request.requestStatusValue.code === '06' && 
                    (this.isAssigned || this.isAdmin() || this.isAudit())
                this.isDraftPosting = this.request.requestStatusValue.code === '07' && 
                    (this.isAssigned || this.isDraft())
                this.isPosted = this.request.requestStatusValue.code === '08' && this.isAssigned
                this.isReposted = this.request.requestStatusValue.code === '14' && this.isAssigned
                this.isScreening = this.request.requestStatusValue.code === '09' && this.isAssigned
                this.isManagerInterviewing = this.request.requestStatusValue.code === '10' 
                this.isPreOffer = this.request.requestStatusValue.code === '16' && this.isAssigned
                this.isSalaryReview = this.request.requestStatusValue.code === '11' &&
                    (this.isAssigned || this.isFfm() || this.isSalary())
                this.isMakeOffer = this.request.requestStatusValue.code === '35'
                this.isBackgroundCheck = this.request.requestStatusValue.code === '13' && this.isAssigned
                this.isComplete = this.request.requestStatusValue.code === '15' && this.isAssigned
                this.isRDCSubmission = this.request.requestStatusValue.code === '18' &&
                        this.isIcsHrm()
                this.isRDCCandidate = this.request.requestStatusValue.code === '19' &&
                    this.isIcsHrm()
                this.isRDCOnboard = this.request.requestStatusValue.code === '20' &&
                    this.isIcsHrm()

                this.isAssignPcn = this.request.transactionQueueStatus === 1 && this.isHRTransactions()
                this.isUpdatePcn = (this.request.transactionQueueStatus === 2 || this.request.transactionQueueStatus === 4) && this.isHRTransactions()
                this.isCloseOut = this.request.transactionQueueStatus === 3 && (this.isHRTransactions() || this.isAdmin())
                this.isTransactionPPL = this.request.transactionQueueStatus === 5 && (this.isHRTransactions() || this.isAdmin())

                this.allowAttachments = (this.request.supervisor && this.request.supervisor.userId &&
                                         this.request.supervisor.userId.toLowerCase() === this.$keycloak.userName.toLowerCase()) ||
                                         (this.request.submitter && this.request.submitter.userId &&
                                         this.request.submitter.userId.toLowerCase() === this.$keycloak.userName.toLowerCase()) ||
                                         this.isAdmin() || this.isSpecialist() || this.isPayroll()
            }
        },
        transitionStatus() {
            this.transitionRequest()
        },
    },
    
    created() {
        this.requestId = this.$route.params.id
        if(this.$route.params.action){
          this.payrollAction = this.$route.params.action
        }

        this.fetchRequest()
        this.fetchLifecycles()
        this.fetchSpecialists()
        this.loadAttachmentTypes()
    },

    methods: {
        getApprover(type) {
            let found = this.request.approvals.find(approval => approval.approvalType == type)
            return found ? found.approver.name : null
        },
        setAssigned() {
          this.isAssigned = false
          this.isPrimaryAssigned = false
          //You can edit because you submitted this request
          if(this.request.requestStatusValue.code === '01'){
            this.isAssigned = this.request.submitter.userId.toLowerCase() === this.$keycloak.userName.toLowerCase()
          }
          //You can edit because you are a leave specialist editing a leave request
          if(_.includes(['10'], this.request.requestTypeValue.code)){
            this.isAssigned = this.isAssigned || this.hasLeaveRole
          }
          //You can edit because you were assigned to this request
          if (this.request.assigned.userId && typeof this.request.assigned.userId === 'string' && this.request.completed === false) {
            this.isAssigned = this.isAssigned || this.request.assigned.userId.toLowerCase() === this.$keycloak.userName.toLowerCase()
            this.isPrimaryAssigned = this.request.assigned.userId.toLowerCase() === this.$keycloak.userName.toLowerCase()
          }
          //You can edit because you are a transactions specialist and this is in the transaction queue for close out
          if (this.request.requestStatusValue.code === '15' && this.request.completed && this.hasTransactionRole && this.request.transactionQueueStatus === 3) {
              this.isAssigned = true
          }
          //You can edit because you have been delegated permissions for this request
          
          if (this.isAssigned === false && this.request.delegate && this.request.delegate.userId && this.request.delegate.userId.toLowerCase() === this.$keycloak.userName.toLowerCase()) {
            this.isAssigned = true
          }
        },
        
        forceLocationRerender(event) {
            //https://michaelnthiessen.com/force-re-render/
            this.keys.location += 1
        },
        forceSupervisorRerender(event) {
            //https://michaelnthiessen.com/force-re-render/
            this.keys.supervisor += 1
        },
        forceDenialRerender(event) {
            this.keys.denial += 1
        },
        forceLeaveTypeRerender(event) {
            this.keys.leaveType += 1
        },
        padPositionNumber() {
            this.request.positionNumber = String(this.request.positionNumber).padStart(8, '0')
        },
        fetchRequest() {
            this.needsMyApproval = false
            this.needsMyICSApproval = false
            this.isDirectorApproval = false
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/request/${this.requestId}`)
                .then(response => {
                    this.initialPageLoading = false
                    this.request = _.merge(this.defaultRequestAttributes, response.data)
                    this.request.approvals = response.data.approvals

                    if(this.request.approvals) {
                      this.needsMyApproval = this.request.approvals.find(a => a.approvalStatus === 'P'
                          && (a.approver.userId.toLowerCase() === this.$keycloak.userName.toLowerCase()))

                      var dir = this.request.approvals.find(approval => approval.approvalType === 'DD')
                      this.isDirectorApproval = dir ? dir.approver.userId.toLowerCase() === this.$keycloak.userName.toLowerCase()
                          && this.needsMyApproval.approvalType === 'DD' : false
                      if (this.request.approvals.length > 1) {
                          var second = this.request.approvals.find(approval => approval.approvalType === 'AC')
                          this.approver = second ? second.approver : {}
                      } else {
                          this.approver = {}
                      }
                    }

                    if (this.request.requestTypeValue.code === '09' && this.request.requestStatusValue.code === '01') {
                        this.checkForICSApproval()
                    }
                    if(this.request.requestTypeValue.code === '03'){
                      this.request.reallocationEffectiveDate = this.request.reallocationEffectiveDate ? this.request.reallocationEffectiveDate : this.request.effectiveStartDate
                    }

                    this.selectedSkills = []
                    this.otherSkillSet = false
                    if (this.request.skillSet) {
                        this.selectedSkills = this.request.skillSet.split("; ")                        
                    }
                    this.changeLeaveTypeOptions()
                    if(this.payrollAction){
                      this.request.requestStatusValue = this.getPayrollActionCodes(this.payrollAction)
                    }

                    if(this.request.payrollActionsString){
                      this.payrollPPL = this.request.payrollActionsString.includes('PPL')
                      this.payrollFMLA = this.request.payrollActionsString.includes('FMLA')
                    }
                    if(this.request.transactionQueueStatus){
                      this.transactionPPL = this.request.transactionQueueStatus === 5
                    }
                    this.loadAttachmentReqs()
                    if (this.request.requestTypeValue.code === '10') {
                        this.fetchStandardComments()
                    }
                })
        },
        fetchStandardComments() {
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/standardcomment`)
                .then(response => {
                    this.standardComments = response.data
                })
        },

        fetchLifecycles() {
          axios.get(`${process.env.VUE_APP_API_BASE_URL}/request/lifecycle/${this.requestId}`)
              .then(response => {
                response.data.forEach(phase => {
                  this.phases.push(phase.requestStatusCode)
                  if(phase.requestStatusCode === "06" && this.auditApprovedDate == null){
                    this.auditApprovedDate = phase.requestStatusOutDatetime
                  }
                  if(phase.requestStatusCode === "11" && this.salaryApprovedDate === null && phase.requestSubStatus !== 'N'){
                    this.salaryApprovedDate = phase.requestStatusOutDatetime
                    this.salaryApprovedBy = phase.userId
                  }
                  if((phase.requestStatusCode === '12' || phase.requestStatusCode === '13') && (phase.comments != null && phase.comments.startsWith("Reoffer Reason:"))){
                    this.reofferReasons.push(phase.comments)
                  }
                })
                this.reofferReasonString = this.reofferReasons.join(";\n");
              })
        },

      loadAttachmentTypes() {
          if (this.hasInternalAttachmentsRole()) {
              axios.get(`${process.env.VUE_APP_API_BASE_URL}/attachment/types/all`)
                  .then(response => {
                      this.attachmentTypes = response.data
                  })
          } else {
              axios.get(`${process.env.VUE_APP_API_BASE_URL}/attachment/types/ext`)
                  .then(response => {
                      this.attachmentTypes = response.data
                  })
          }
      },

      loadAttachmentReqs() {
        axios.post(`${process.env.VUE_APP_API_BASE_URL}/attachment/requirements`, {statusCode: this.request.requestStatusValue.code})
            .then(response => {
              for (let i=0; i<response.data.length; i++) {
                let index = this.attachmentRequirements.findIndex(e => e.value === response.data[i].attachmentTypeValue.code)
                if (index < 0) {
                  let obj = {
                    value: response.data[i].attachmentTypeValue.code,
                    text: response.data[i].attachmentTypeValue.description,
                    required: [],
                    optional: []
                  }
                  if (response.data[i].required) {
                    obj.required.push(response.data[i].requestTypeValue.code)
                  } else {
                    obj.optional.push(response.data[i].requestTypeValue.code)
                  }
                  this.attachmentRequirements.push(obj)
                } else {
                  if (response.data[i].required) {
                    this.attachmentRequirements[index].required.push(response.data[i].requestTypeValue.code)
                  } else {
                    this.attachmentRequirements[index].optional.push(response.data[i].requestTypeValue.code)
                  }
                }
              }
            })
      },

      requiredAttachments() {
        let results = []
        if (this.request.requestTypeValue) {
          for (let i = 0; i < this.attachmentRequirements.length; i++) {
            if (this.attachmentRequirements[i].required
                .includes(this.request.requestTypeValue.code)) {
              results.push(this.attachmentRequirements[i])
            }
          }
        }
        return results;
      },

        findPayrollActionStatus(code) {
            var result = _.some(this.phases, _.matches(code.toString()))
            return result
        },

        checkForICSApproval() {
            this.needsMyICSApproval = false
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/request/hasrole/ics`)
                .then(response => { 
                    if (response.data === true) {
                        this.needsMyICSApproval = {
                            id: this.request.id,
                            approvalStatus: '',
                            comments: '',
                        }
                    }
                })
        },
        onSubmit() {
            this.$v.needsMyApproval.$touch();
            if (this.$v.needsMyApproval.$invalid) {
                this.$nextTick(() => {
                    document.getElementById('form-container').scrollIntoView()
                    if (!this.$v.needsMyApproval.approverValid) {
                        this.showRootToast("Approval Decision Error", "The 2nd approver cannot be the same as 1st Approver if they are also the Hiring Manager/Supervisor or Request Initiator", "danger")
                    }
                })
                return
            }
            this.isProcessing = true
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/approval`,
                    this.needsMyApproval)
                  .then(response => { 
                      this.isProcessing = false
                     this.showRootToast("Approval Decision Updated", "Your approval decision has been recorded.", "success")
                     this.$router.push('/home')
                      })
        },

        onICSApproval() {
            this.$v.needsMyICSApproval.$touch();
            if (this.$v.needsMyICSApproval.$invalid) {
                this.$nextTick(() => {
                    document.getElementById('form-container').scrollIntoView()
                })
                return
            }
            this.isProcessing = true
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/icsapproval`,
                    this.needsMyICSApproval)
                  .then(response => { 
                      this.isProcessing = false
                     this.showRootToast("Approval Decision Updated", "Your ICS approval decision has been recorded.", "success")
                     this.$router.push('/home')
                      })
        },
        putOnHold() {
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/transition`,
                    {
                        id: this.request.id,
                        transitionStatusTo: '05'
                    })
                  .then(response => { 
                  this.request = response.data
                  
                    this.showToast("Request Phase Updated", "This request has been put on hold.", "success") })
        },

        delegateRequest() {
          axios.post(`${process.env.VUE_APP_API_BASE_URL}/delegate/update`,
                    {
                        requestId: this.request.id,
                        removeDelegate: false, 
                        delegateUserId: this.request.delegate.userId
                    })
                  .then(response => {
                    this.showToast("Request Updated", "The delegation of this request has been updated.", "success")
                     })
        },

        removeDelegate() {
          axios.post(`${process.env.VUE_APP_API_BASE_URL}/delegate/update`,
                    {
                        requestId: this.request.id,
                        removeDelegate: true
                    })
                  .then(response => {
                    this.showToast("Request Updated", "The delegation of this request has been updated.", "success")
                     })
        },

        removeHold() {
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/removeHold`,
                    {
                        requestId: this.request.id
                    })
                  .then(response => {
                    this.request = response.data
                    this.showToast("Request Phase Updated", "The hold has been removed.", "success")
                     })
        },
        cancelRequest() {
             let payload = {
                id: this.request.id,
                transitionStatusTo: '17'
            }

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/transition`, payload)
                  .then(response => { 
                    this.showRootToast("Request Cancelled", 
                        "The reqeust has been cancelled.", "success")
                     this.$router.push('/home')
                  })                  

        },
        reopenLeave(){
          axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/transition`,
              {
                id: this.request.id,
                transitionStatusTo: '02'
              })
              .then(response => {
                this.request = response.data

                this.showToast("Request Phase Updated", "This leave request has been reopened.", "success") }
              )
        },
        showToast(title, message, type) {
            this.$bvToast.toast(message, {
                  title: title,
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: type,
                  appendToast: true
                })

        },
        showRootToast(title, message, type) {
            this.$root.$bvToast.toast(message, {
                  title: title,
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: type,
                  appendToast: true
                })

        },
        transitionRequest() {
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/transition`,
                    {
                        id: this.request.id,
                        transitionStatusTo: this.transitionStatus
                    })
                  .then(response => { 
                  this.request = response.data })
        },
      getFileType(value) {
        for (let i=0; i<this.attachmentTypes.length; i++) {
          if (this.attachmentTypes[i].code == value) {
            return this.attachmentTypes[i].description
          }
        }
        return 'Unknown'
      },

      hasAttachment(attachmentType) {
        let found = this.request.attachments.find(a => a.type === attachmentType)
        return found
      },

        toggleEdit(needsReset) {
          if(this.isEditing && needsReset){
            //We are currently editing and we want to cancel
            this.$v.$reset();
            this.request = Object.assign({},this.previousRequest)
          }
          else{
            //we are going to make edits so we should have some previous stored up
            this.previousRequest = Object.assign({},this.request)
          }
         this.isEditing = !this.isEditing
        },
        toggleAttachments() {
         this.isEditingAttachments = !this.isEditingAttachments
        },
        addAttachment(value) {
            if (Array.isArray(this.request.attachments) && this.request.attachments.length) {
                this.request.attachments.push(value)
            } else {
                this.request.attachments = []
                this.request.attachments.push(value)
            }
        },
        removeAttachment(idx, item) {
            axios.delete(`${process.env.VUE_APP_API_BASE_URL}/attachment/${item.id}`)
                .then(response => {
                    this.request.attachments.splice(idx, 1)
                })                
        },
        saveEdits() {
            this.request.skillSet = this.selectedSkills.join("; ")
            if(this.getLeavePayrollActions() !== "") {
              this.request.payrollActionsString = this.getLeavePayrollActions()
            }else{
              delete this.request.payrollActionsString
            }
            if(this.transactionPPL){
              this.request.transactionQueueStatus = 5
            }
            else{
              delete this.request.transactionQueueStatus;
            }

             axios.put(`${process.env.VUE_APP_API_BASE_URL}/request`, this.request)
                  .then(response => {
                    this.showRootToast("Request Updated", "Your changes were applied.", "success")
                    if(this.transactionPPL){
                      this.showRootToast("Action Created", "Transaction action created.", "success")
                    }
                    if(this.getLeavePayrollActions() !== ""){
                      this.showRootToast("Action Created", "Payroll action(s) created.", "success")
                    }
                    this.fetchRequest()
                    this.toggleEdit(false)
                  })
        },
        saveComment() {
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/comment`, this.request)
                .then(response => {
                    this.showRootToast("Comment Created", "Your comment was added.", "success")
                    this.request.standardLeaveComment = null
                    this.request.leaveComment = null
                    this.request.leaveComments = response.data
                })
        },
        toggleDirectorEdit(needsReset) {
            this.request = Object.assign({}, this.request)
            if(this.isDirectorEditing && needsReset){
                //We are currently editing and we want to cancel
                this.$v.$reset();
                this.request = Object.assign({},this.previousRequest)
            }
            else{
                //we are going to make edits so we should have some previous stored up
                this.previousRequest = Object.assign({},this.request)
            }
            this.isDirectorEditing = !this.isDirectorEditing
        },
        saveDirectorEdits() {
            this.$v.approver.$touch();
            if (this.$v.approver.$invalid) {
                return
            }
            let payload = {
                positionId: this.requestId,
                approver: this.approver,
            }
            axios.put(`${process.env.VUE_APP_API_BASE_URL}/request/update`, payload)
                .then(response => {
                    this.showRootToast("Request Updated", "Your changes were applied.", "success")
                    this.fetchRequest()
                    this.toggleDirectorEdit(false)
                })
        },
        goBack(){
          //This is not good enough, need a way to save the state of searching
          this.$router.back()
        },

        close() {
            this.$bvModal.hide('pcnUpdateModal')
        },

        savePcnRequest() {
            let payload = {
                requestId: this.request.id,
                requestText: this.request.pcnUpdateComment
            }

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/transactions/pcnupdate`, payload)
                .then(response => { 
                    this.$bvToast.toast('PCN Update Request Submitted', {
                        title: 'Status',
                        toaster: 'b-toaster-top-center',
                        solid: true,
                        variant: 'success',
                        appendToast: true
                    }) 
                });          
            this.close()
        },

        translate(code) {
            var result = 'not provided'
            this.flsaStatusOptions.forEach((item) => {
                if (item.value === code) {
                    result = item.text
                }
            })
            return result
        },

        translateBU(code) {
            var result = 'not provided'
            this.bargainingUnitOptions.forEach((item) => {
                if (item.value === code) {
                    result = item.text
                }
            })
            return result
        },
        
        changeLeaveTypeOptionsAndClear() {
            this.changeLeaveTypeOptions()
            this.request.typeOfCovidLeave = null
        },

        changeLeaveTypeOptions() {
            this.leaveTypeSubOptions = []

            if (this.request.leaveType === 'COVID/EFMLA') {
                this.leaveTypeSubOptions = this.covidLeaveTypeOptions      
            } 
            if (this.request.leaveType === 'FMLA') {
                this.leaveTypeSubOptions = this.fmlaLeaveTypeOptions
            }
            if (this.request.leaveType === 'Contractual') {
                this.leaveTypeSubOptions = this.contractLeaveTypeOptions
            }
        },
        getPayrollActionCodes(payrollAction) {
          if(payrollAction === 'REV'){
              return {code: 38, description: 'Closeout Payroll Review'}
          }
          if(payrollAction === 'PPL'){
            return {code: 30, description: 'PPL Leave - Payroll'}
          }
          if(payrollAction === 'FMLA'){
            return {code: 31, description: 'FMLA Leave - Payroll'}
          }
          return null
        },
      getLeavePayrollActions() {
          let actions = [];
          if(this.payrollPPL){
            actions.push('PPL')
          }
          if(this.payrollFMLA){
            actions.push('FMLA')
          }
        return actions.join(',');
      },

      fetchSpecialists() {
        axios.get(`${process.env.VUE_APP_API_BASE_URL}/organization/delegate`)
                .then(response => {
                   this.specialists = []

                    response.data.forEach((person) => {
                        let option = {
                            value: person.userId,
                            text: person.name
                        }
                        this.specialists.push(option)
                    }) 
                });
      },
      validateNewApprover() {
          let dd = this.request.approvals.find(approval => approval.approvalType === 'DD')?.approver?.userId.toUpperCase()
          let second = this.approver?.userId.toUpperCase()
          return (this.request && this.request.approvals)
              && !((second === this.request.supervisor?.userId.toUpperCase()) || (second === this.request.submitter?.userId.toUpperCase()))
              || (second !== dd)
      },
      validateDefaultApprover() {
          let second = this.request.approvals.find(approval => approval.approvalType === 'AC')?.approver?.userId.toUpperCase()
          let dd = this.request.approvals.find(approval => approval.approvalType === 'DD')?.approver?.userId.toUpperCase()
          return (this.request && this.request.approvals)
              && !((second === this.request.supervisor?.userId.toUpperCase()) || (second === this.request.submitter?.userId.toUpperCase()))
              || (second !== dd)
      },

      maxLengthAlert(event) {
        let newValue = event.target.value;
        if (newValue.length >= this.projectMaxLength) {
          event.preventDefault()
          this.address = this.previousAddress;
          this.displayWarning = true;
        }
        else {
          this.address = newValue;
          this.previousAddress = newValue;
          this.displayWarning = false;
        }
      },
        getSema4AttributesOfCurrentPcn(pcn) {
          axios.get(`${process.env.VUE_APP_ADMINWS_API_BASE_URL}/sema4/${pcn}`)
            .then(response => {
              if (response.data.length > 0)  {
                this.pcnSema4Attributes = response.data

                this.loading = false
              } else {
                this.pcnSema4Attributes = ['']
              }
            }).catch(() => {
            this.pcnSema4Attributes = ['']
            this.pcnSema4Attributes.posCd = "Error finding PCN."
          })
          axios.get(`${process.env.VUE_APP_ADMINWS_API_BASE_URL}/sema4/${pcn}/funding`)
            .then(response => {
              if (response.data.length > 0)  {
                this.fundingData = response.data
                this.fundingData.isValid = ''

              } else {
                this.fundingData = ['']
                this.fundingData.isValid = 'No PCN funding data found.'
              }
            }).catch(() => {
            this.fundingData.isValid = "Error finding PCN funding data."
          })
        },

        getSema4AsOfDate() {
            const today = new Date();
            today.setDate(today.getDate() - 1);
            const date = today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate();
            return date;
        }
    }
}
</script>

<style>
.card {
    margin-bottom: 18px;
}
.card-header {
    font-weight: 700;
}
</style>
